import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Company } from 'src/app/core/interfaces/company';
import { DataPaymenCargo } from 'src/app/core/interfaces/dataPaymenCargo';
import { RequestApprovalCargo } from 'src/app/core/interfaces/requestApprovalCargo';
import { CargoBillingComponent } from 'src/app/modules/cargo/cargo-billing/cargo-billing.component';
import { CargoUpdateComponent } from 'src/app/modules/cargo/cargo-update/cargo-update.component';
import { DialogComponent } from '../dialog/dialog.component';
import { BillingConfirmationDialogComponent } from '../billing-confirmation-dialog/billing-confirmation-dialog.component';
import { BillingConfirmationDialogData, BillingConfirmationDialogResult, BillingConfirmationItem } from 'src/app/core/interfaces/billingConfirmationDialog';
import {
  groupCargosByTransportCompany, groupPreBillsByTransportCompany, resolveCargosTransportNit, TransportCompanyBillingGroup
} from 'src/app/core/resources/transport-company-context.utils';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/services/authentication.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { FreightListService } from 'src/app/modules/cargo/cargo-list/cargo-list.service';
import { Titles } from 'src/app/core/resources/titles';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaymentTypePipe } from 'src/app/core/pipe/paymentType.pipe';
import { DateManager } from 'src/app/core/managers/date.manager';
import { CurrencyPipe } from '@angular/common';
import { CargoDetailService } from 'src/app/modules/cargo/cargo-detail/cargo-detail.service';
import { SiigoManager } from 'src/app/core/managers/siigo.manager';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { CargoBillingXmlComponent } from 'src/app/modules/cargo/cargo-billing-xml/cargo-billing-xml.component';
import { CargoCashReceiptsComponent } from 'src/app/modules/cargo/cargo-cash-receipts/cargo-cash-receipts.component';
import { CargoCreditNoteAssociationComponent } from 'src/app/modules/cargo/cargo-credit-note-association/cargo-credit-note-association.component';
import { CargoCreditNoteAssociationSummaryComponent } from 'src/app/modules/cargo/cargo-credit-note-association-summary/cargo-credit-note-association-summary.component';
import { AccialCreditNoteAssociationResponse } from 'src/app/core/interfaces/accial-credit-note';
import { ApproveCargoDialogComponent } from '../approve-cargo-dialog/approve-cargo-dialog.component';
import { CargoApprovalRequest, CargoApprovalRequestBalance } from 'src/app/core/interfaces/cargo-approval-request';
import { ReceivableModificationsComponent } from 'src/app/modules/administration/receivable/receivable-modifications/receivable-modifications.component';
import { EMPTY, of, Subscription } from 'rxjs';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { TransportCompanyGuardService } from 'src/app/core/services/transport-company-guard.service';
import { SaasTransportCompanyService } from 'src/app/core/services/saas-transport-company.service';
import { SaasTransportCompany } from 'src/app/core/interfaces/saasTransportCompany';
import { TransportCompany } from 'src/app/core/interfaces/transportCompany';
import { delay, switchMap } from 'rxjs/operators';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { ReceivableService } from 'src/app/modules/administration/receivable/receivable.service';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { environment } from 'src/environments/environment';
import { MassivePaymentsComponent } from 'src/app/modules/cargo/massive-payments/massive-payments.component';
import { AlertAdvancePaymentComponent } from 'src/app/modules/cargo/alert-advance-payment/alert-advance-payment.component';
import { ListOperationsService } from './list-operations.service';
import { MoveAdvanceDialogComponent } from 'src/app/modules/cargo/move-advance-dialog/move-advance-dialog.component';
import { MassiveCargoOperationComponent } from 'src/app/modules/cargo/massive-cargo-operation/massive-cargo-operation.component';
import { CargoOperationByPlateComponent } from 'src/app/modules/cargo/cargo-operation-by-plate/cargo-operation-by-plate.component';
import { IntegrationEnum } from 'src/app/core/enums/integration.enum';
import { ConsignmentCargo } from 'src/app/core/interfaces/consignmentCargo';
import { TravelExpense } from 'src/app/core/interfaces/travel-expense';
import { SelectableItem } from 'src/app/core/interfaces/selectableItem';
import { CargoGenerateFilterComponent } from 'src/app/modules/cargo/cargo-generate-filter/cargo-generate-filter.component';
import { CargoPaymentsService } from 'src/app/core/services/cargo-payments.service';
import { GeneralConfigService } from 'src/app/core/services/general-config.service';
import { Destination } from 'src/app/core/interfaces/destination';
import { FingerprintHistory } from 'src/app/core/interfaces/fingerprintHistory';
import {
  DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE,
  isDocumentRecreationInProgress
} from 'src/app/core/resources/transport-company-change.utils';
import {
  CargoPaymentPreviewResponse,
  CargoPaymentPreviewSwitches,
  CargoPaymentPreviewType
} from 'src/app/core/interfaces/bank-account-payment-detail';
type PaymentType = "advance" | "extraAdvance" | "additionalCost" | "balance" | "travelExpenses";
@Component({
  selector: 'app-list-operations',
  templateUrl: './list-operations.component.html',
  styleUrls: ['./list-operations.component.scss'],
  providers: [SiigoManager]
})
export class ListOperationsComponent implements OnInit {
  @Input() filterBy: "cargo" | "company" | "vehicle" | "user" = "cargo";
  @Input() typeList: string;
  @Input() itemsSelecteds: Cargo[];
  @Input() options: FilterModel[];
  @Input() filters: string;
  @Output() showDialog: EventEmitter<any> = new EventEmitter();
  @Output() refreshActualList: EventEmitter<any> = new EventEmitter();
  @Output() resetActualList: EventEmitter<any> = new EventEmitter();

  permission = Permission;
  isRootNit: boolean;
  cargoTabsLoadingRoutes = [
    "emptyContainers",
    "urbanRoutes",
    "lastMileRoutes",
    "nationalRoutes",
    "internationalRoutes"
  ];
  staticFilters = {};
  holder: any;

  isSomeErrorApproveCargos: boolean = false;
  companyToOperations = new FormControl('', Validators.required);
  validateToOperations: string = '';
  optionsCompany: OptionsAutocomplete = {
    title: 'Compañía',
    optionAll: false,
  };
  firstLoadsToPay: Cargo[] = [];
  firstItemsSelecteds: Cargo[] = [];
  itemsSelectedTravelExpenses: { [key: string]: TravelExpense[] } = {};
  totalTravelExpensesBalance = 0;
  inputExtraAdvance: FormControl;
  rndcContingencyActive: boolean = false;
  rndcContingencySub: Subscription;
  constructor(
    private authService: AuthService,
    public snackBarService: SnackBarService,
    private transportCompanyGuard: TransportCompanyGuardService,
    private permissionRole: PermissionRole,
    private freightListService: FreightListService,
    public titles: Titles,
    public utils: Utils,
    public dialog: MatDialog,
    public spinner: NgxSpinnerService,
    private paymentTypePipe: PaymentTypePipe,
    private currencyPipe: CurrencyPipe,
    private cargoDetailService: CargoDetailService,
    private siigoManager: SiigoManager,
    public matDialog: MatDialog,
    public receivableService: ReceivableService,
    private vehiclesService: VehiclesService,
    private cargoManager: CargoManager,
    private listOperationsService: ListOperationsService,
    private cargoPaymentsService: CargoPaymentsService,
    private generalConfigService: GeneralConfigService,
    private saasTransportCompanyService: SaasTransportCompanyService
  ) { }

  ngOnInit() {
    this.isRootNit = this.authService && this.authService.userIsFromRootNit();
    this.setOptions();
    this.listenRndcContingencyState();
  }

  private listenRndcContingencyState(): void {
    this.rndcContingencySub = this.generalConfigService.rndcContingency$.subscribe((value: boolean) => this.rndcContingencyActive = value);
  }

  setAllFilters() {
    if (this.filters && this.filters !== "null") {
      this.filters.split("&").forEach((filter) => {
        if (filter && filter.split("=")[1] && filter.split("=")[1] !== "undefined")
          this.staticFilters[filter.split("=")[0]] = decodeURIComponent(filter.split("=")[1]);
      })
    } else {
      this.staticFilters = {};
    }
    this.ngOnInit();
  }

  setOptions() {
    if (this.staticFilters && this.staticFilters['nit']) {
      this.optionsCompany = {
        title: this.companyFieldTitle,
        optionAll: true,
        initialNit: this.staticFilters['nit'],
      }
    } else if (this.optionsCompany.title !== this.companyFieldTitle) {
      this.optionsCompany = { ...this.optionsCompany, title: this.companyFieldTitle };
    }
    if (!this.isRootNit) this.validateToOperations = 'disable';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.filters && changes.filters.currentValue) this.setAllFilters();
    if (changes && changes.itemsSelecteds && changes.itemsSelecteds.currentValue) {
      this.setCompanyByItemsSelected();
      if (this.canPayTravelExpenses) this.setTotalTravelExpenses();
    }
  }


  /**
   * Llena el cliente con el de los servicios seleccionados cuando todos son del mismo; si son de
   * varios (o alguno no tiene), lo deja vacío para que no quede uno anterior que no les corresponde.
   */
  private setCompanyByItemsSelected() {
    if (!this.itemsSelecteds.length) return;
    const companyIds = this.itemsSelecteds.map(item => item.idCompany || null)
      .filter((companyId, index, list) => list.indexOf(companyId) === index);
    this.optionsCompany = {
      title: this.companyFieldTitle,
      optionAll: true,
      initialNit: companyIds.length === 1 && companyIds[0] ? companyIds[0] : "",
    }
  }

  /** En Facturación el campo es el cliente a facturar; se nombra así para no confundirlo con la empresa de transporte. */
  get companyFieldTitle(): string {
    return this.typeList === 'charges' ? 'Cliente a facturar' : 'Compañía';
  }

  private async setTotalTravelExpenses() {
    if (this.itemsSelecteds.length) {
      Object.keys(this.itemsSelectedTravelExpenses).forEach(key => {
        if (!this.itemsSelecteds.some(cargo => cargo.id === key))
          delete this.itemsSelectedTravelExpenses[key];
      });
      const notSearchTravelExpenses = this.itemsSelecteds.filter(cargo => !this.itemsSelectedTravelExpenses[cargo.id]);
      const cargoTravelExpenses = await this.freightListService.getTotalValueTravelExpenses(notSearchTravelExpenses);
      cargoTravelExpenses.forEach(object => {
        this.itemsSelectedTravelExpenses[object.cargo.id] = object.travelExpenses;
      });
    }
    else this.itemsSelectedTravelExpenses = {};
  }

  get isTabLoadingRoutes(): boolean {
    return this.typeList && this.cargoTabsLoadingRoutes.includes(this.typeList);
  }
  //Funciones adicionales
  //Enviar reportes
  get showSendReport() {
    return (this.typeList && this.typeList == 'loadingRoutes') || this.isTabLoadingRoutes;
  }
  public sendReport() {
    this.validateToOperations = 'touched';
    this.companyToOperations.markAsTouched();
    if (this.companyToOperations.value && this.companyToOperations.value.companyId) {
      this.showDialog.emit(this.companyToOperations.value);
    } else {
      this.snackBarService.openSnackBar("Debe seleccionar una compañia", undefined, "alert");
    }
  }


  get showOperations(): boolean {
    return this.isCargoPayment || this.canConfirmCargoPayment || this.canFulfillRndc
      || this.canConfirmEntryPayment || this.canApproveCargos || this.canModifyBill
      || this.canModifyVoucher || this.canGenerateJournal || this.canPayTravelExpenses;
  }

  get canPayTravelExpenses(): boolean {
    return this.typeList === 'paymentTravelExpenses' &&
      this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.paymentTravelExpenses);
  }

  get isCargoPayment(): boolean {
    return this.canPayAdvance || this.canPayBalance || this.canPayAdditionalCosts || this.canPayExtraAdvance;
  }
  get canPayAdvance(): boolean { //No requiere compañía
    return this.options && this.options.some(option => option.filterName === Filter.showFilterPaymentAdvanceCargo) &&
      this.freightListService.canPayAdvance(this.typeList).isSelectable;
  }
  get canPayBalance(): boolean {
    return this.options && this.options.some(option => option.filterName === Filter.showFilterPaymentBalanceCargo) &&
      this.freightListService.canPayBalance(this.typeList).isSelectable;
  }
  get canPayAdditionalCosts(): boolean {
    return this.options && this.options.some(option => option.filterName === Filter.showFilterPaymentAdditionalCostsCargo) &&
      this.freightListService.canPayAdditionalCosts(this.typeList).isSelectable;
  }
  get canPayExtraAdvance(): boolean { //No requiere compañía
    return this.options && this.options.some(option => option.filterName === Filter.showFilterPaymentExtraAdvanceCargo) &&
      this.freightListService.canPayExtraAdvance(this.typeList).isSelectable;
  }
  get canConfirmCargo(): boolean {
    return this.options &&
      this.options.some(option => option.filterName === Filter.showFilterCharges);
  }
  get canConfirmCargoPayment(): boolean {
    return this.canConfirmCargo && this.staticFilters['cashed'] === 'false';
  }
  get canConfirmEntryPayment(): boolean {
    return this.canConfirmCargo && this.staticFilters['cashed'] === 'true'
      && this.staticFilters['checked'] === 'false';
  }
  get canApproveCargos(): boolean {
    return this.options
      && this.options.some(option => option.filterName === Filter.showFilterAprovedCargo);
  }
  get canFulfillRndc(): boolean {
    return this.options && this.options.some(option => option.filterName === Filter.showFilterMinistryFulfillment)
      && this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.fulFillCargosRndc);
  }
  get canModifyBill(): boolean {
    return this.canConfirmCargo && this.staticFilters['cashed'] === 'true'
      && this.staticFilters['checked'] !== '';
  }
  get canModifyVoucher(): boolean {
    return this.canConfirmCargo && this.staticFilters['cashed'] === 'true'
      && this.staticFilters['checked'] === 'true';
  }

  get canGenerateJournal(): boolean {
    return this.typeList === 'withoutPayment' && this.options &&
      this.options.some(option => option.filterName === Filter.showFilterCreationDateInitial);
  }

  get typePaymentByTab(): PaymentType | string {
    let cargoTabsTypePayment = {
      paymentAdvanceCargo: "advance",
      paymentExtraAdvanceCargo: "extraAdvance",
      paymentAdditionalCostsCargo: "additionalCost",
      paymentBalanceCargo: "balance",
      paymentTravelExpenses: 'travelExpenses'
    };
    return this.typeList && cargoTabsTypePayment[this.typeList] ? cargoTabsTypePayment[this.typeList] : "";
  }

  get totalValueAdvanceCargos() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalValueAdvanceCargos(this.itemsSelecteds)
      : 0;
  }

  get totalValueBalanceCargos(): number {
    if (this.filterBy !== 'cargo' || !this.itemsSelecteds || !this.itemsSelecteds.length) return 0;
    return this.itemsSelecteds.reduce((total, cargo) => {
      if (cargo.shippingCost && (cargo.shippingCost.paid || cargo.shippingCost.balanceState)) return total;
      const travelExpensesBalance = this.cargoPaymentsService.getTravelExpensesBalance(cargo.travelExpenses, cargo);
      return total + (this.cargoPaymentsService.getTotalValueBalance(cargo) - travelExpensesBalance);
    }, 0);
  }

  get totalValueTravelExpensesCargos(): number {
    if (!Object.keys(this.itemsSelectedTravelExpenses).length) return 0;
    return Object.values(this.itemsSelectedTravelExpenses).reduce((acc, travelExpenses) => acc + travelExpenses.reduce((acc, travelExpense) => travelExpense && !travelExpense.paid ? acc + travelExpense.totalPaid : acc, 0), 0);
  }

  get totalValueTravelExpensesByType() {
    const type = this.staticFilters['travelExpensesType'];
    if (!Object.keys(this.itemsSelectedTravelExpenses).length) return 0;
    return Object.values(this.itemsSelectedTravelExpenses).reduce((acc, travelExpenses) => acc + travelExpenses.reduce((acc, travelExpense) => travelExpense && !travelExpense.paid && travelExpense.travelExpensesType && travelExpense.travelExpensesType.name === type ? acc + travelExpense.totalPaid : acc, 0), 0);
  }

  get cargosWithTravelExpenses(): boolean {
    const cargos = this.itemsSelecteds.filter((cargo) => {
      return !this.utils.isEmpty(cargo.travelExpenses);
    });
    return !!cargos.length;
  }

  get totalValueRateCargos() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalValueRateCargos(this.itemsSelecteds)
      : 0;
  }

  get totalAdditionals() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalAdditionals(this.itemsSelecteds)
      : 0;
  }
  get totalAdditionalCosts() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalAdditionalCosts(this.itemsSelecteds)
      : 0;
  }

  get totalAdditionalStandBy() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalAdditionalStandBy(this.itemsSelecteds)
      : 0;
  }
  get totalAdditionalCostsStandBy() {
    return this.filterBy === "cargo"
      ? this.freightListService.getTotalAdditionalCostsStandBy(this.itemsSelecteds)
      : 0;
  }

  get totalValueUploadCargos() {
    return this.filterBy === "cargo"
      ? this.freightListService.totalValueUploadCargos(this.itemsSelecteds)
      : 0;
  }
  get totalValueDownloadCargos() {
    return this.filterBy === "cargo"
      ? this.freightListService.totalValueDownloadCargos(this.itemsSelecteds)
      : 0;
  }
  get totalValueStandByCargos() {
    return this.filterBy === "cargo"
      ? this.freightListService.totalValueStandByCargos(this.itemsSelecteds)
      : 0;
  }

  async openModalPaymentTravelExpenses() {
    if (!this.itemsSelecteds.length) return;
    for (const cargo of this.itemsSelecteds) {
      const canPayTravelExpenses = this.freightListService.isCargoToPayTravelExpenses(cargo, this.typeList, this.filters);
      if (!canPayTravelExpenses.isEnabled && canPayTravelExpenses.errorMessage)
        return this.snackBarService.openSnackBar(canPayTravelExpenses.errorMessage, undefined, "alert");
    }

    if (this.authService && !this.authService.getCompany().bankAccounts || this.authService.getCompany().bankAccounts.length === 0)
      return this.snackBarService.openSnackBar("La empresa no tiene cuentas bancarias registradas en el sistema", undefined, "alert");

    let listAccount = this.authService && this.authService.getCompany().bankAccounts;
    if (!listAccount.length)
      return this.snackBarService.openSnackBar("La empresa no tiene cuentas bancarias registradas para este pago", undefined, "alert");
    listAccount = listAccount.filter(account => account.accountType !== 'Fintech Innovbo');

    if (!this.totalValueTravelExpensesByType)
      return this.snackBarService.openSnackBar("No hay viáticos para pagar", undefined, "alert");

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: this.titles.titlesModalFileForPaymentsTravelExpenses, viewSelect: true,

      listLabel: "Seleccione un método de pago",
      list: this.utils.listToDefault(listAccount as [], "accountNumber", "Pagar con "),
      inputText: true, placeholder: "Descripción del pago", maxLength: 15,
      description: (this.itemsSelecteds.length > 1 ? 'Se seleccionaron las cargas: ' : 'Se seleccionó la carga: ') +
        this.utils.getItemsCheked(this.itemsSelecteds, "consecutive").join(', ') +
        `, Total de viáticos: ${this.currencyPipe.transform(this.totalValueTravelExpensesByType, 'COP', 'code')}`
    };

    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);

    const cargos: Array<string> = this.utils.getItemsCheked(this.itemsSelecteds, "id");
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        const findTravelExpenseByType = (cargo: Cargo): TravelExpense => {
          return cargo.travelExpenses.find(travelExpense => this.utils.getNestedValue(travelExpense, 'travelExpensesType.name') === this.staticFilters['travelExpensesType'] && !travelExpense.paid);
        }
        const data: DataPaymenCargo = {
          travelExpenses: this.itemsSelecteds.map((cargo: Cargo) => findTravelExpenseByType(cargo) ? findTravelExpenseByType(cargo).id : null),
          cargos: cargos.filter((value, index) => cargos.indexOf(value) === index),
          bankAccount: {
            accountTypeCode: result.itemSelected.accountTypeCode,
            accountType: result.itemSelected.accountType,
            accountNumber: result.itemSelected.accountNumber,
          },
          description: result.inputText,
        };

        this.getFileForPaymentsCargo(data, 0, this.typePaymentByTab, false);
      } else {
        if (this.firstItemsSelecteds.length) this.itemsSelecteds = this.firstItemsSelecteds;
      }
    });
  }

  get canPayWithLoggiCash(): { canPay: boolean, error?: string } {
    if (!this.itemsSelecteds.length) return { canPay: false, error: 'No hay cargos seleccionados' };
    if (this.authService && !this.authService.getCompany().bankAccounts || this.authService.getCompany().bankAccounts.length === 0)
      return { canPay: false, error: 'La empresa no tiene cuentas bancarias registradas en el sistema' };
    const account = this.authService.getCompany().bankAccounts.find(account => account.accountType === 'Fintech Innovbo');
    if (!account) return { canPay: false, error: 'Fintech Innovbo está deshabilitado para tu empresa, contacta al equipo comercial para habilitarlo' };
    if (this.canPayBalance && !this.filters.includes('fastPayment=true'))
      return { canPay: false, error: 'El servicio de Fintech Innovbo solo puede ser utilizado para pronto pago' };
    return { canPay: true };
  }

  async openModalPaymentCargo(type?: string) {
    if (!this.itemsSelecteds.length || this.filterBy !== "cargo") return;
    if (this.authService && !this.authService.getCompany().bankAccounts || this.authService.getCompany().bankAccounts.length === 0)
      return this.snackBarService.openSnackBar("La empresa no tiene cuentas bancarias registradas en el sistema", undefined, "alert");
    if (type === 'fintech' && !this.canPayWithLoggiCash.canPay)
      return this.snackBarService.openSnackBar(this.canPayWithLoggiCash.error, undefined, "alert");

    for (const cargo of this.itemsSelecteds) {
      let canPayService: SelectableItem = { isSelectable: false };
      if (this.canPayExtraAdvance)
        canPayService = this.freightListService.isCargoToPayExtraAdvance(cargo, this.typeList);
      else if (this.canPayBalance)
        canPayService = this.freightListService.isCargoToPayBalance(cargo, this.typeList, this.filters);
      else if (this.canPayAdditionalCosts)
        canPayService = this.freightListService.isCargoToPayAdditionalCosts(cargo, this.typeList, this.filters);
      else if (this.canPayAdvance)
        canPayService = this.freightListService.isCargoToPayAdvance(cargo, this.typeList, this.filters);
      if (!canPayService.isEnabled && canPayService.errorMessage)
        return this.snackBarService.openSnackBar(canPayService.errorMessage, undefined, "alert");
    }
    if ((!type || (type && type !== 'availableLoadsToPayAdvance')) && sessionStorage.getItem('_activeTab') === 'paymentAdvanceCargo'
      && !this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.unrestrictedAdvancePayments)) {
      let stateAdvance: boolean = await this.checkStateAdvanceLoads();
      if (stateAdvance) return;
    }
    if (this.authService && !this.authService.getCompany().bankAccounts || !this.authService.getCompany().bankAccounts.length)
      return this.snackBarService.openSnackBar("La empresa no tiene cuentas bancarias registradas para este pago", undefined, "alert");

    let listAccount = this.authService.getCompany().bankAccounts.filter(account =>
      this.canPayExtraAdvance
        ? account.purpose === "All" || account.purpose.toLowerCase() === "extraAdvance"
        : account.purpose === "All" || account.purpose.toLowerCase() === this.typePaymentByTab
    );
    if (!(this.canPayAdvance || (this.canPayBalance && this.freightListService.canPaySoon(this.typeList, this.filters))))
      listAccount = listAccount.filter(account => account.accountType !== 'Fintech Innovbo');

    if (!listAccount.length)
      return this.snackBarService.openSnackBar("La empresa no tiene cuentas bancarias registradas para este pago", undefined, "alert");
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      title: this.titles.titlesModalFileForPaymentsCargo,
      viewSelect: true,
      listLabel: "Seleccione un método de pago",
      list: this.utils.listToDefault(listAccount as [], "accountNumber", "Pagar con "),
      inputText: true, placeholder: "Descripción del pago", maxLength: 15,
    };

    this.spinner.show();
    // El preview solo aplica a anticipo y saldo. Sobre anticipo queda por fuera
    // porque su monto lo escribe el usuario dentro de este mismo modal.
    const paymentType = this.typePaymentByTab;
    const previewPaymentType: CargoPaymentPreviewType | null = type !== 'fintech' &&
      (paymentType === 'advance' || paymentType === 'balance') ? paymentType : null;
    if (type === 'fintech') {
      dialogConfig.data['title'] = this.titles.titleFintech;
      delete dialogConfig.data['viewSelect']
      delete dialogConfig.data['listLabel']
      delete dialogConfig.data['list']
    }

    if (
      this.permissionRole
        .hasPermission(
          this.permission.cargo.module,
          this.permission.cargo.payWithTravelExpenses
        ) && sessionStorage.getItem('_activeTab') === 'paymentAdvanceCargo'
    ) {
      await this.setTotalTravelExpenses();
      const totalValueTravelExpensesCargos = this.totalValueTravelExpensesCargos;
      let text: string = '';
      if (this.itemsSelecteds.length > 1) {
        if (type === 'fintech') text = 'Los siguientes servicios se enviarán a LoggiCash: ';
        else text = 'Se seleccionaron los servicios: ';
      } else {
        if (type === 'fintech') text = 'El siguiente servicio se enviará a LoggiCash: ';
        else text = 'Se seleccionó el servicio:';
      }
      dialogConfig.data.descriptionHTML = `
        ${(text) +
        this.utils.getItemsCheked(this.itemsSelecteds, "consecutive").join(', ')}<br/>
      `;

      dialogConfig.data.descriptionHTML += `Recuerde que el pago del anticipo <b>incluye los viáticos</b> registrados en cada servicio.<br/>`;

      if (this.totalValueTravelExpensesCargos) dialogConfig.data['checkbox'] = [{
        id: "payWithTravelExpenses",
        name: "Incluir pago de viáticos"
      }]
      let rows = `
        <tr>
          <th style="text-align:left;padding:0 1rem;font-weight:600;color:#333;">
            Categoría
          </th>
          <td style="text-align:right;padding:0 1rem;color:#555;">
            ${this.mapTabList(this.typePaymentByTab)}
          </td>
        </tr>
        <tr>
          <th style="text-align:left;padding:0 1rem;font-weight:600;color:#333;">
            Cantidad de servicios
          </th>
          <td style="text-align:right;padding:0 1rem;color:#555;">
            ${this.itemsSelecteds.length}
          </td>
        </tr>

        <tr>
          <th style="text-align:left;padding:0 1rem;font-weight:600;color:#333;">
            Total servicios adicionales
          </th>
          <td style="text-align:right;padding:0 1rem;color:#555;" class="hide-content">
            0 COP
          </td>
          <td style="text-align:right;padding:0 1rem;color:#555;display:none" class="show-extra-content">
            ${this.totalAdditionalCosts ? this.currencyPipe.transform(this.totalAdditionalCosts, 'COP', 'code') : '0 COP'}
          </td>
        </tr>

        <tr>
          <th style="text-align:left;padding:0 1rem;font-weight:600;color:#333;">
            Total viáticos
          </th>
          <td style="text-align:right;padding:0 1rem;color:#555;">
            ${totalValueTravelExpensesCargos ? this.currencyPipe.transform(totalValueTravelExpensesCargos, 'COP', 'code') : '0 COP'}
          </td>
        </tr>
      `;

      rows += `
        <tr style="background-color: rgba(0, 0, 0, 0.05);">
          <th style="text-align:left;padding:0 1rem;font-weight:600;color:#333;">
            Total a desembolsar
          </th>
          <td style="text-align:right;padding:0 1rem;color:#555;" class="hide-content total">
            ${this.currencyPipe.transform(this.totalValueAdvanceCargos + totalValueTravelExpensesCargos, 'COP', 'code')}
          </td>
          <td style="text-align:right;padding:0 1rem;color:#555;display:none" class="show-extra-content total">
            ${this.currencyPipe.transform(this.totalValueAdvanceCargos + totalValueTravelExpensesCargos + this.totalAdditionalCosts, 'COP', 'code')}
          </td>
        </tr>
      `;
      dialogConfig.data.descriptionHTML += `
        <table
          style="
            margin: 1rem auto;
            border-collapse: collapse;
            width: auto;
            font-family: sans-serif;
          "
        >
          ${rows}
        </table>
      `;
    }

    if (this.typeList === 'paymentExtraAdvanceCargo') {

      dialogConfig.data = {
        title: this.titles.titleModalExtraAdvance,
        viewSelect: true,
        listLabel: "Seleccione un método de pago",
        list: this.utils.listToDefault(listAccount as [], "accountNumber", "Pagar con "),
        inputText: true,
        placeholder: "Descripción del pago",
        maxLength: 15,
      };
      const promises = this.itemsSelecteds.map(async (item, index) => {
        const balance = await this.cargoPaymentsService.getBalance(item, false, item.travelExpenses)
        const totalValue = this.currencyPipe.transform(balance, 'COP');
        const consecutive = item.consecutive;
        return `
          <tr class="${index % 2 === 0 ? 'even-row' : 'odd-row'}">
            <td style="font-weight: 700; font-size: 15px; padding-right: 100px;">${consecutive}</td>
            <td style="font-size: 15px; padding-right: 100px;">${totalValue}</td>
          </tr>
          `;
      });
      const description = (await Promise.all(promises)).join('');
      dialogConfig.data.descriptionHTML = `
           <table style="font-size: 15px; width: auto; margin: 0 auto; border-radius: 18px;" class="table">
            <thead>
              <tr style="font-weight: 700; background-color: #584796; color: white;">
                <th>ID Servicio</th>
                <th>Saldo disponible</th>
              </tr>
            </thead>
              <tbody>
                ${description}
              </tbody>
          </table>
        `;
      const valueMaxAdvance: number = await this.calculateMinBalance(this.itemsSelecteds);
      const minBalance = this.currencyPipe.transform(valueMaxAdvance, 'COP');
      if (this.itemsSelecteds.length > 1) {
        dialogConfig.data.descriptionHTML += ` <br/>
      <div class="alert alert-info m-3 d-flex align-items-center justify-content-center" role="alert">
        <p style="font-size: 15px; text-align: center;">
          <i class="fas fa-exclamation-circle"></i><span style="font-weight: 700; font-size: 15px;">El limite maximo de pago para el sobre anticipo es de ${minBalance}.</span>
          <br/>
          <span style="font-size: 15px; display: inline-block; margin: 0 auto;">Si deseas pagar otro monto te recomendamos pagar uno a uno</span>
        </p>
      </div>`;
      }
    }
    if (this.canPayExtraAdvance) {
      dialogConfig.data['inputExtraAdvance'] = true;
      dialogConfig.data['placeholderAdvance'] = "Ingrese el valor del Sobre Anticipo";
      dialogConfig.data['minAdvance'] = "100 COP";
      dialogConfig.data['maxAdvance'] = this.totalValueBalanceCargos;
    }

    if (previewPaymentType) {
      dialogConfig.data.paymentPreviewLabel = 'Ver detalle de pagos';
      dialogConfig.data.paymentPreviewDialogWidth = ModalEnum.LARGE_WIDTH;
      dialogConfig.data.paymentPreviewCargoIds = this.selectedCargoIds;
      dialogConfig.data.loadPaymentPreview = (switches: CargoPaymentPreviewSwitches) =>
        this.getCargoPaymentPreview(previewPaymentType, switches);
    }

    const canPayAdditionalCosts: boolean = this.itemsSelecteds.some(cargo => cargo.additionalCosts && cargo.additionalCosts.some(cost =>
      cost && cost.financialInformation && !cost.financialInformation.paid &&
      (cost.type && (cost.type.name === "Servicio cargue" || cost.type.name === "Servicio descargue") && this.typePaymentByTab === "advance")
      || (cost.type && (cost.type.name === "Servicio cargue" || cost.type.name === "Servicio descargue" || cost.type.name === "Stand by") && this.typePaymentByTab === "balance")
    ));

    if (canPayAdditionalCosts) {
      const objCheck = {
        id: "payWithAdditionalCost",
        name: "Incluir pago de servicios adicionales"
      };
      if (dialogConfig.data['checkbox'] && dialogConfig.data['checkbox'].length) {
        dialogConfig.data['checkbox'].push(objCheck);
      } else {
        dialogConfig.data['checkbox'] = [objCheck];
      }
    }

    if (this.typeList === 'paymentExtraAdvanceCargo') {
      if (this.itemsSelecteds.length > 1) dialogConfig.data.maxAdvance = await this.calculateMinBalance(this.itemsSelecteds);
      else dialogConfig.data.maxAdvance = this.totalValueBalanceCargos;
    }

    this.spinner.hide();
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if ((!result || !result.state) && type && type === 'massive') this.itemsSelecteds = [];
      if (result && result.state) {
        let data: DataPaymenCargo;
        if (type === 'fintech') {
          const fintechAcc = this.authService.getCompany().bankAccounts.find(account => account.accountType === 'Fintech Innovbo');
          data = {
            cargos: this.utils.getItemsCheked(this.itemsSelecteds, "id"),
            bankAccount: {
              accountTypeCode: fintechAcc.accountTypeCode,
              accountType: fintechAcc.accountType,
              accountNumber: fintechAcc.accountNumber,
            },
            description: result.inputText,
          };
        } else {
          data = {
            cargos: this.utils.getItemsCheked(this.itemsSelecteds, "id"),
            bankAccount: {
              accountTypeCode: result.itemSelected.accountTypeCode,
              accountType: result.itemSelected.accountType,
              accountNumber: result.itemSelected.accountNumber,
            },
            description: result.inputText,
          };
        }
        let payWithAdditionalCost = false;
        let payWithTravelExpenses = false;
        if (result.checkbox && result.checkbox.length) {
          const iPayWithAdditionalCost = result.checkbox.findIndex(
            (obj) => obj.id === 'payWithAdditionalCost'
          );
          payWithAdditionalCost = iPayWithAdditionalCost >= 0;
          if (sessionStorage.getItem('_activeTab') === 'paymentAdvanceCargo') {
            const iPayWithTravelExpenses = result.checkbox.findIndex(
              (obj) => obj.id === 'payWithTravelExpenses'
            );
            payWithTravelExpenses = iPayWithTravelExpenses >= 0;
          }
        }
        if (sessionStorage.getItem('_activeTab') === 'paymentBalanceCargo') {
          payWithTravelExpenses = this.cargosWithTravelExpenses;
        }
        this.getFileForPaymentsCargo(
          data,
          result.inputExtraAdvance,
          this.typePaymentByTab,
          payWithAdditionalCost,
          payWithTravelExpenses,
          type
        );
      } else {
        if (this.firstItemsSelecteds.length) this.itemsSelecteds = this.firstItemsSelecteds;
      }
    });
  }

  private async calculateMinBalance(cargos: Cargo[]) {
    // Calculate the minimum available balance for the selected services
    const promises = cargos.map(cargo =>
      this.cargoPaymentsService.getBalance(cargo, false, cargo.travelExpenses)
    );
    let result = await Promise.all(promises);
    return Math.min(...result);
  }

  private get selectedCargoIds(): string[] {
    return this.itemsSelecteds
      .map(cargo => cargo && cargo.id)
      .filter((id): id is string => !!id)
      .filter((id, index, ids) => ids.indexOf(id) === index);
  }

  /**
   * Consulta el preview del pago con los mismos parámetros que va a recibir
   * `cargo/payments/generate`: si difieren, los valores mostrados no serían los
   * que se transfieren. El error se propaga para que el diálogo lo informe.
   */
  private async getCargoPaymentPreview(
    paymentType: CargoPaymentPreviewType,
    switches: CargoPaymentPreviewSwitches
  ): Promise<CargoPaymentPreviewResponse> {
    const cargos = this.selectedCargoIds;
    if (!cargos.length) return null;

    return this.freightListService.getCargoPaymentPreview(
      { cargos },
      {
        paymentType,
        payWithAdditionalCost: switches.payWithAdditionalCost,
        payWithTravelExpenses: this.payWithTravelExpensesForPayment(switches.payWithTravelExpenses)
      }
    ).toPromise();
  }

  /**
   * Replica cómo se resuelve `payWithTravelExpenses` al generar el pago:
   * sin permiso el parámetro no se envía y el back aplica su valor por defecto;
   * en saldo lo determinan los viáticos de los servicios y no un switch.
   */
  private payWithTravelExpensesForPayment(checked: boolean): boolean | undefined {
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.payWithTravelExpenses))
      return undefined;
    if (sessionStorage.getItem('_activeTab') === 'paymentBalanceCargo') return this.cargosWithTravelExpenses;
    return checked;
  }

  private mapTabList(type: "advance" | "extraAdvance" | "additionalCost" | "balance" | "travelExpenses" | string) {
    switch (type) {
      case "advance":
        return "Anticipos";
      case "extraAdvance":
        return "Sobre anticipos"
      case "additionalCost":
        return "Servicios adicionales"
      case "balance":
        return "Saldo"
      case "travelExpenses":
        "Viáticos"
      default:
        return type;
    }
  }

  private mapPaymentStatusToSpanish(status: string): string {
    switch ((status || '').toUpperCase()) {
      case 'CONFIRMED':
        return 'Confirmado';
      case 'PROCESSING':
        return 'En procesamiento';
      case 'FAILED':
        return 'Fallido';
      default:
        return status;
    }
  }

  private openPaymentResultsDialog(paymentResults: any[]): void {
    if (!paymentResults || !paymentResults.length) return;

    const dialogConfig = new MatDialogConfig();
    const rows = paymentResults.map((result, index) => {
      const status = this.mapPaymentStatusToSpanish(result && result.status ? result.status : '');
      const consecutive = result && result.consecutive ? result.consecutive : '-';
      const message = result && result.message ? result.message : '-';
      const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';

      return `
        <tr class="${rowClass}">
          <td style="padding: 0.5rem 1rem; text-align: center;">${consecutive}</td>
          <td style="padding: 0.5rem 1rem; text-align: center;">${status}</td>
          <td style="padding: 0.5rem 1rem; text-align: left;">${message}</td>
        </tr>
      `;
    }).join('');

    dialogConfig.data = {
      title: 'Resumen de pagos',
      descriptionHTML: `
        <p class="text-center">
          Se generó el siguiente resumen para los pagos realizados:
        </p>
        <table style="font-size: 14px; width: 100%; border-collapse: collapse; margin-top: 0.5rem;">
          <thead>
            <tr style="background-color: #02d7dc; color: white;">
              <th style="padding: 0.5rem 1rem; text-align: center;">Consecutivo</th>
              <th style="padding: 0.5rem 1rem; text-align: center;">Estado</th>
              <th style="padding: 0.5rem 1rem; text-align: left;">Mensaje</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
        </table>
      `,
      hideBtnCancel: true
    };

    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;

    this.dialog.open(DialogComponent, dialogConfig);
  }

  private base64ToBlob(base64: string, contentType: string = 'text/plain'): Blob {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: contentType });
    } catch (e) {
      return new Blob([]);
    }
  }

  private buildPaymentFileName(): string {
    return "Pago-" +
      this.paymentTypePipe.transform(this.typePaymentByTab) +
      "-Servicios-" +
      DateManager.dateToString(new Date(), 'YYYY-MM-DD HH-mm');
  }

  private isPaymentResponse(data: any): boolean {
    return !!data && (data.paymentResults !== undefined || data.file !== undefined);
  }

  private normalizePaymentFormat(value: any): 'txt' | 'xls' | 'xlsx' {
    const format = (value || '').toString().toLowerCase();
    if (format.indexOf('xlsx') !== -1) return 'xlsx';
    if (format.indexOf('xls') !== -1) return 'xls';
    return 'txt';
  }

  private resolvePaymentFormat(success: any, parsedBody?: any): 'txt' | 'xls' | 'xlsx' {
    if (success && (success.format || success.fileType))
      return this.normalizePaymentFormat(success.format || success.fileType);
    if (parsedBody && (parsedBody.format || parsedBody.fileType))
      return this.normalizePaymentFormat(parsedBody.format || parsedBody.fileType);
    if (success && success.headers && typeof success.headers.get === 'function') {
      const headerFormat = success.headers.get('format') || success.headers.get('fileType');
      if (headerFormat) return this.normalizePaymentFormat(headerFormat);
      const contentType = success.headers.get('content-type');
      if (contentType) return this.normalizePaymentFormat(contentType);
    }
    return 'txt';
  }

  private getPaymentContentType(format: 'txt' | 'xls' | 'xlsx'): string {
    if (format === 'xlsx') return 'application/xslx';
    if (format === 'xls') return 'application/xls';
    return 'text/plain;charset=utf-8';
  }

  private downloadPaymentFile(file: Blob | string, fileName: string, format: 'txt' | 'xls' | 'xlsx'): void {
    const contentType = this.getPaymentContentType(format);
    const fileBlob = file instanceof Blob
      ? file
      : new Blob([file], { type: contentType });

    this.utils.downloadFile(fileBlob, fileName, contentType);
  }

  private downloadPaymentBody(body: any, fileName: string, format: 'txt' | 'xls' | 'xlsx'): void {
    if (body instanceof Blob) {
      this.downloadPaymentFile(body, fileName, format);
      return;
    }

    const content = typeof body === 'string' ? body : JSON.stringify(body || {});
    this.downloadPaymentFile(content, fileName, format);
  }

  private processPaymentResponseData(data: any, fileName: string, format: 'txt' | 'xls' | 'xlsx'): void {
    if (!this.isPaymentResponse(data)) return;

    if (data.file) {
      const blobFromBase64 = this.base64ToBlob(data.file, this.getPaymentContentType(format));
      this.downloadPaymentFile(blobFromBase64, fileName, format);
    }

    if (Array.isArray(data.paymentResults)) {
      this.openPaymentResultsDialog(data.paymentResults);
    }
  }

  private blobToText(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(typeof fileReader.result === 'string' ? fileReader.result : '');
      fileReader.onerror = () => reject(fileReader.error);
      fileReader.readAsText(blob);
    });
  }

  private processPaymentDownload(success: any, fileName: string, finishFlow: () => void): void {
    const body = success && success.body !== undefined ? success.body : success;

    if (body instanceof Blob) {
      this.blobToText(body)
        .then((text: string) => {
          try {
            const parsedBody = JSON.parse(text);
            if (this.isPaymentResponse(parsedBody)) {
              const format = this.resolvePaymentFormat(success, parsedBody);
              this.processPaymentResponseData(parsedBody, fileName, format);
              return;
            }
          } catch (e) {
            // If the blob is not JSON, download the original bytes as txt or excel.
          }

          const format = this.resolvePaymentFormat(success);
          this.downloadPaymentBody(body, fileName, format);
        })
        .catch(() => {
          const format = this.resolvePaymentFormat(success);
          this.downloadPaymentBody(body, fileName, format);
        })
        .finally(() => finishFlow());
      return;
    }

    const format = this.resolvePaymentFormat(success, this.isPaymentResponse(body) ? body : null);
    if (this.isPaymentResponse(success) || this.isPaymentResponse(body)) {
      this.processPaymentResponseData(this.isPaymentResponse(success) ? success : body, fileName, format);
    } else {
      this.downloadPaymentBody(body, fileName, format);
    }

    finishFlow();
  }

  /**
  * This method check the state of the loads in route to advance payment.
  */
  async checkStateAdvanceLoads() {
    this.firstLoadsToPay = [];
    const matchLoadsByVehicle: { [licensePlate: string]: Cargo[] } = {};
    let licensePlates = [...new Set(this.itemsSelecteds
      .map(cargo => cargo && cargo.licensePlate)
    )];
    this.spinner.show();
    for (const licensePlate of licensePlates) {
      if (licensePlate) {
        let matchLoads: Cargo[] = await this.listOperationsService.getLoadsToPayByParameters('licensePlate', licensePlate);
        if (matchLoads && matchLoads.length) {
          matchLoadsByVehicle[licensePlate] = matchLoads;
          this.firstLoadsToPay.push(matchLoads[0]);
          matchLoads = [];
        }
      }
    }
    this.spinner.hide();
    // Si hay servicios en ruta con anticipo de dicha placa y si hay alguna de las placas con mas de un servicio en ruta.
    // Ademas si todos los servicios seleccionados son validas deberia dejar seguir el flujo.
    let hasDifferentCargo: boolean = false;
    if (this.firstLoadsToPay.length) {
      hasDifferentCargo = this.itemsSelecteds.some(cargo =>
        !this.firstLoadsToPay.map(load => load.consecutive).includes(cargo.consecutive)
      );
    }
    if (Object.keys(matchLoadsByVehicle).length > 0 && Object.values(matchLoadsByVehicle).some(cargos => cargos.length > 1) && hasDifferentCargo) {
      this.openAlertAdvancePayment(matchLoadsByVehicle);
      return true;
    }
    return false;
  }

  /**
  * This method open a dialog that shows an alert related with the advance payment of the loads.
  */
  openAlertAdvancePayment(matchLoadsByVehicle: { [licensePlate: string]: Cargo[] }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      matchLoadsByVehicle
    };
    dialogConfig.width = ModalEnum.FULL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.FORMS_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(
      AlertAdvancePaymentComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.loads && result.loads.length) {
          this.firstItemsSelecteds = this.utils.clone(this.itemsSelecteds);
          this.itemsSelecteds = result.loads.map((load: Cargo) => {
            load.checked = true;
            return load;
          });
          this.openModalPaymentCargo('availableLoadsToPayAdvance');
        }
        else if (result.state && result.state === 'loadDeletedOrFinished') this.openModalPaymentCargo();
      }
    });
  }

  getFileForPaymentsCargo(dataPayment?: any, extraAmount?, type?, payWithAdditionalCost?: boolean, payWithTravelExpenses?: boolean, actionType?: string) {
    let paymentType = type === "additionalCost"
      ? this.staticFilters["additionalCost"] === "Servicio cargue"
        ? "additionalServicesLoad"
        : this.staticFilters["additionalCost"] === "Servicio descargue"
          ? "additionalServicesDownload"
          : this.staticFilters["additionalCost"] === "Stand by"
            ? "additionalServicesLoadStandBy"
            : type
      : type;
    this.spinner.show();
    this.freightListService.getFileForPaymentsCargo(dataPayment, paymentType, extraAmount, payWithAdditionalCost, payWithTravelExpenses, actionType)
      .subscribe(
        (success: any) => {
          this.resetActualList.emit();
          if (actionType === 'fintech' || (dataPayment && dataPayment.bankAccount && dataPayment.bankAccount.accountType === "Fintech Innovbo")) {
            this.refreshActualList.emit(true);
            this.spinner.hide();
            if (success.failedPaymentRequest && success.failedPaymentRequest.length) {
              let message = "Ocurrió un error al enviar la informacion a LoggiCash";
              if (success.failedPaymentRequest[0].message === 'Must indicate a customer discount percentage') {
                message = "Debe indicar un porcentaje de descuento para el cliente";
              }
              this.snackBarService.openSnackBar(
                message,
                undefined,
                "error"
              );
              return;
            }
            if (localStorage.getItem('showFintechDialog') === null && this.permissionRole.hasPermission(this.permission.fintech.module,
              this.permission.payments.loggiappPaymentExecute)) this.openLoggiCashDialog();
            else this.snackBarService.openSnackBar("Los servicios han sido enviados a LoggiCash correctamente", undefined, "success");
          } else {
            this.snackBarService.openSnackBar(
              "Se descargará el archivo en breve"
            );
            const fileName = this.buildPaymentFileName();
            const finishFlow = () => {
              of(null).pipe(delay(1500)).subscribe(() => {
                this.refreshActualList.emit(true);
                this.spinner.hide();
              });
            };

            this.processPaymentDownload(success, fileName, finishFlow);
          }

        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar(
            "Ocurrió un error al enviar la informacion",
            undefined,
            "error"
          );
        }
      );
  }

  // Dialogo de confirmacion para abrir loggicash
  private openLoggiCashDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: '¡Servicios enviados a LoggiCash!',
      description: '¿Desea abrir LoggiCash en una nueva pestaña para continuar con el pago de estos servicios?',
      checkbox: [{
        id: "dontShowDialogAgain",
        name: "No volverme a mostrar este mensaje."
      }],
      labelButton2: 'Ir a LoggiCash',
      hideBtnConfirm: true,
    }
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.checkbox && result.checkbox.length) localStorage.setItem('showFintechDialog', JSON.stringify(false));
      if (result && result.refuse === 'Ir a LoggiCash') {
        this.spinner.show();
        await this.authService.redirectToLoggiCash();
        this.spinner.hide();
      }
    })
  }
  //Confirmar cobro e ingreso de servicios
  /** transportCompanyId: empresa del grupo elegido en la confirmación; si no viene, la de la pastilla. */
  openModalCashedCargo(typeBilling: 'bill' | 'income', cargos?: Cargo[], transportCompanyId?: string) {
    const items = cargos && cargos.length ? cargos : this.itemsSelecteds;
    if (!items.length || this.filterBy !== "cargo") return;
    this.validateToOperations = 'touched';
    if (!this.companyToOperations.value || !this.companyToOperations.value.companyId)
      return this.snackBarService.openSnackBar("Debe seleccionar una compañia", undefined, "alert");
    if (!items.every(cargo => cargo.idCompany === this.companyToOperations.value.companyId))
      return this.snackBarService.openSnackBar("Todos los servicios deben pertenecer a la compañía seleccionada", undefined, "alert");

    let idsWithBill = [];
    let idsWithoutBill = [];
    items.forEach((element) => {
      if (!element.shippingCost.billId && !element.expeditionDateBill) {
        idsWithBill.push(element.consecutive);
      } else if (!element.shippingCost.billId && element.expeditionDateBill) {
        idsWithoutBill.push(element.consecutive);
      }
    });
    if (this.hasIntegration(typeBilling) && this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.billingWithFlexibilityChoice
    ))
      this.selectTypeBilling(typeBilling, cargos, transportCompanyId);
    else if (idsWithBill.length && !idsWithoutBill.length && this.hasIntegration(typeBilling)) {
      this.openDialogBillWithIntegration(typeBilling, cargos, transportCompanyId);
    } else if ((idsWithBill.length && !idsWithoutBill.length) || (!idsWithBill.length && idsWithoutBill.length)) {
      this.openDialogEditBill(cargos, transportCompanyId);
    } else if (!idsWithBill.length && !idsWithoutBill.length) {
      this.snackBarService.openSnackBar('Los servicios ya fueron facturados', undefined, 'alert');
    } else {
      this.openErrorBills(idsWithBill, idsWithoutBill);
    }
  }
  checkSameCompanyId(cargo: Cargo): boolean {
    return this.companyToOperations.value && this.companyToOperations.value.companyId
      && cargo.idCompany === this.companyToOperations.value.companyId;
  }

  async openModalCashedCargoMassive(typeBilling: 'bill' | 'income') {
    this.validateToOperations = 'touched';
    if (!this.companyToOperations.value || !this.companyToOperations.value.companyId)
      return this.snackBarService.openSnackBar("Debe seleccionar una compañia", undefined, "alert");
    // Con empresas de transporte se busca sin filtrar por la de la pastilla: así los servicios de otra
    // empresa se muestran en su grupo (antes aparecían como "No encontrado/registrado").
    const usesTransportCompanies = this.usesTransportCompanyGroups;
    const storageFilters = this.transformStorageFiltersToSearchFilters();
    const filtersToSearch = usesTransportCompanies ? this.withoutTransportCompanyFilter(storageFilters) : storageFilters;
    const validationFunc = (cargo: Cargo): SelectableItem => {
      if (!this.checkSameCompanyId(cargo))
        return { isSelectable: false, isEnabled: false, errorMessage: 'Todos los servicios deben pertenecer a la compañía seleccionada' };
      if (typeBilling === 'bill')
        return this.freightListService.isCargoToBill(cargo, this.typeList, this.filters);
      return { isSelectable: true, isEnabled: true, errorMessage: '' };
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Confirmar ${typeBilling === 'bill' ? 'cobro' : 'ingreso'} de servicios`,
      subtitle: `Ingrese los consecutivos de los servicios que desea confirmar 
      su ${typeBilling === 'bill' ? 'cobro' : 'ingreso'} separados por una coma.`,
      label: "Servicios a confirmar",
      confirmButton: "Continuar",
      method: this.freightListService.getListCargo.bind(this.freightListService),
      validationToCheckValid: validationFunc,
      filters: filtersToSearch
    }
    let result: {
      availableList: Cargo[],
      unavailableList: Cargo[],
      nonExistentList: number[],
      consecutiveList: string[]
    } = await this.dialog.open(MassiveCargoOperationComponent, dialogConfig).afterClosed().toPromise();
    if (!result) return;
    // Habilitados por empresa de transporte; los que no tienen empresa pasan a error.
    const grouping = usesTransportCompanies ? groupCargosByTransportCompany(result.availableList) : null;
    const groups: TransportCompanyBillingGroup[] = grouping ? grouping.groups : [];
    const withoutTransportCompany: Cargo[] = grouping ? grouping.withoutTransportCompany : [];
    const billableCargos: Cargo[] = grouping ? result.availableList.filter(cargo => !withoutTransportCompany.includes(cargo)) : result.availableList;
    const hasErrors = result.availableList.length !== result.consecutiveList.length || !!withoutTransportCompany.length;
    if (hasErrors || groups.length > 1) {
      const items: BillingConfirmationItem[] = [];
      billableCargos.forEach(cargo => {
        items.push({ consecutive: cargo.consecutive, cargo });
      });
      result.unavailableList.forEach(cargo => items.push({
        consecutive: cargo.consecutive, cargo, errorMessage: validationFunc(cargo).errorMessage || 'Servicio inhabilitado'
      }));
      withoutTransportCompany.forEach(cargo => items.push({
        consecutive: cargo.consecutive, cargo, errorMessage: ServiceMessages.CARGO_WITHOUT_TRANSPORT_COMPANY
      }));
      result.nonExistentList.forEach(consecutive => items.push({ consecutive, kind: 'servicio', errorMessage: 'No encontrado/registrado' }));
      const confirmed = await this.openBillingConfirmationDialog({
        title: billableCargos.length ? '¿Deseas continuar?' : 'No es posible continuar',
        cargosToBill: grouping ? [] : billableCargos,
        items,
        canContinue: !!billableCargos.length,
        emptyMessage: 'No hay ningún servicio habilitado',
        groups,
        listTransportCompanyId: this.listTransportCompanyId
      });
      if (!confirmed) return;
      return this.openModalCashedCargo(typeBilling, confirmed.cargos || billableCargos, confirmed.transportCompanyId);
    }

    this.openModalCashedCargo(typeBilling, billableCargos, groups.length ? groups[0].transportCompanyId : undefined);
  }

  /** Agrupar por empresa solo aplica en SaaS con servicios de transporte (las demás no tienen empresa). */
  private get usesTransportCompanyGroups(): boolean {
    return !!(this.authService && this.authService.hasTransportServicesCompany);
  }

  /**
   * Nombres de las empresas de transporte por NIT: del listado de la SaaS y, si falla,
   * del transportCompany de los servicios. Lo que no se resuelva se muestra con el NIT.
   */
  private async getTransportCompanyNames(cargos: Cargo[]): Promise<{ [transportCompanyId: string]: string }> {
    const names: { [transportCompanyId: string]: string } = {};
    (cargos || []).forEach(cargo => {
      if (cargo && cargo.transportCompany && cargo.transportCompany.id && cargo.transportCompany.name)
        names[cargo.transportCompany.id] = cargo.transportCompany.name;
    });
    try {
      const companies: SaasTransportCompany[] = await this.saasTransportCompanyService.list().toPromise();
      (companies || []).forEach(company => { if (company && company.companyId && company.name) names[company.companyId] = company.name; });
    } catch (error) { }
    return names;
  }

  private withoutTransportCompanyFilter(filters: string): string {
    return (filters || '').split('&').filter(part => part && !part.startsWith('transportCompanyId=')).map(part => '&' + part).join('');
  }

  selectTypeBilling(typeBilling: 'bill' | 'income', cargos?: Cargo[], transportCompanyId?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Por favor selecciona que tipo de facturacion deseas usar',
      labelButton1: 'Facturación manual',
      labelButton2: 'Facturación por integración',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.height = 'auto';
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.refuse) {
        result.refuse === 'Facturación por integración'
          ? this.openDialogBillWithIntegration(typeBilling, cargos, transportCompanyId)
          : this.openDialogEditBill(cargos, transportCompanyId);
      }
    });
  }

  public openDialogBillWithIntegration(typeBilling: string, cargos?: Cargo[], selectedTransportCompanyId?: string) {
    const cargosToBill: Cargo[] = cargos && cargos.length ? cargos : this.utils.getItemsCheked(this.itemsSelecteds);
    // Centros de costo, vendedores y medios de pago dependen de la empresa de transporte:
    // no se factura una mezcla ni servicios de otra empresa distinta a la elegida (grupo o pastilla).
    const transportCompanyId = selectedTransportCompanyId || this.listTransportCompanyId;
    if (!this.transportCompanyGuard.ensureSameTransportCompany(cargosToBill, transportCompanyId)) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      transportCompanyId,
      cargos: cargosToBill,
      nitCompany: this.companyToOperations.value.companyId,
      company: this.companyToOperations.value,
      typeBilling,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.dialog.open(CargoBillingComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.authService.getAllCompanies().toPromise().finally();
        this.refreshActualList.emit(true);
      }
    });
  }
  public openDialogEditBill(cargos?: Cargo[], selectedTransportCompanyId?: string) {
    const cargosToBill: Cargo[] = cargos && cargos.length ? cargos : this.utils.getItemsCheked(this.itemsSelecteds);
    // Incluye los servicios que llegan de una prefactura.
    if (!this.transportCompanyGuard.ensureSameTransportCompany(cargosToBill, selectedTransportCompanyId || this.listTransportCompanyId)) return;
    const dialogConfig = new MatDialogConfig();
    const title = `Atar número de factura manualmente`;
    dialogConfig.data = {
      title: title,
      cargos: cargosToBill,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(CargoUpdateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshActualList.emit(true);
      }
    });
  }

  public async openDialogBillByPreBill() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Facturar por Prefactura',
      companyId: this.companyToOperations.value.companyId,
    };
    dialogConfig.height = 'auto';
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    let result: {
      preBillConsecutives: number[],
      availablePreBillList: number[],
      availableCargoList: Cargo[],
      availableCargosByPreBill?: { consecutive: number, cargos: Cargo[], transportCompany?: TransportCompany }[],
      unavailablePreBillList: { consecutive: number, errorMessage?: string, cargos?: Cargo[] }[],
      nonExistentPreBillList: number[],
      unavailableCargoList?: { cargo: Cargo, errorMessage?: string }[],
      companyId?: string
    } = await this.dialog.open(CargoUpdateComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.preBillConsecutives || !result.preBillConsecutives.length) return;
    const extraMessages: string[] = [];
    const items: BillingConfirmationItem[] = [];
    // Con empresas de transporte: se agrupa por la empresa de la prefactura. Una prefactura sin empresa
    // o con servicios de otra empresa no se puede facturar (la barrera del cobro la bloquearía igual).
    const groups: TransportCompanyBillingGroup[] = [];
    if (this.usesTransportCompanyGroups && result.availableCargosByPreBill) {
      const billablePreBills = result.availableCargosByPreBill.filter(preBill => {
        const preBillTransportCompanyId = preBill.transportCompany && preBill.transportCompany.id;
        if (!preBillTransportCompanyId) {
          items.push({ consecutive: preBill.consecutive, kind: 'prefactura', errorMessage: ServiceMessages.PRE_BILL_WITHOUT_TRANSPORT_COMPANY_ASSIGNED });
          return false;
        }
        const resolved = resolveCargosTransportNit(preBill.cargos);
        if (!resolved.consistent || (resolved.transportNit && resolved.transportNit !== preBillTransportCompanyId)) {
          items.push({ consecutive: preBill.consecutive, kind: 'prefactura', errorMessage: ServiceMessages.PRE_BILL_CARGOS_FROM_OTHER_TRANSPORT_COMPANY });
          return false;
        }
        return true;
      });
      const names = await this.getTransportCompanyNames(billablePreBills.reduce((list, preBill) => list.concat(preBill.cargos), []));
      groups.push(...groupPreBillsByTransportCompany(billablePreBills, names).groups);
      result.availableCargoList = groups.reduce((list, group) => list.concat(group.cargos), []);
      result.availablePreBillList = groups.reduce((list, group) => list.concat(group.preBills), []);
    } else if (result.availablePreBillList && result.availablePreBillList.length) {
      extraMessages.push(`Prefacturas a facturar: ${result.availablePreBillList.join(', ')}`);
    }
    result.unavailablePreBillList && result.unavailablePreBillList.length
      && extraMessages.push(`Prefacturas inhabilitadas: ${result.unavailablePreBillList.map(preBill =>
        `${preBill.consecutive}${preBill.errorMessage ? ' - ' + preBill.errorMessage : ''}`).join(', ')}`);
    result.nonExistentPreBillList && result.nonExistentPreBillList.length
      && extraMessages.push(`Prefacturas no encontradas/registradas: ${result.nonExistentPreBillList.join(', ')}`);

    (result.availableCargoList || []).forEach(cargo => {
      items.push({ consecutive: cargo.consecutive, kind: 'servicio', cargo });
    });
    (result.unavailableCargoList || []).forEach(item => items.push({
      consecutive: item.cargo.consecutive,
      cargo: item.cargo,
      errorMessage: item.errorMessage
    }));
    (result.unavailablePreBillList || []).forEach(preBill => {
      if (!(preBill.cargos && preBill.cargos.length))
        items.push({ consecutive: preBill.consecutive, kind: 'prefactura', errorMessage: preBill.errorMessage });
    });
    (result.nonExistentPreBillList || []).forEach(consecutive =>
      items.push({ consecutive, kind: 'prefactura', errorMessage: 'No encontrada/registrada' })
    );

    const confirmed = await this.openBillingConfirmationDialog({
      title: result.availablePreBillList.length ? '¿Deseas continuar?' : 'No es posible continuar',
      cargosToBill: groups.length ? [] : (result.availableCargoList || []),
      items,
      canContinue: !!(result.availablePreBillList && result.availablePreBillList.length),
      emptyMessage: 'No hay ninguna prefactura habilitada',
      extraMessages,
      groups,
      listTransportCompanyId: this.listTransportCompanyId
    });
    if (!confirmed) return;
    // Empresa cliente completa (como en el flujo masivo): el cobro lee de ella billingConfiguration.expirationDays.
    const companies: Company[] = (this.authService && this.authService.getCompanies()) || [];
    const preBillCompany: Company = companies.find(company => company && company.companyId === result.companyId);
    this.companyToOperations.setValue(preBillCompany || { companyId: result.companyId });

    this.openModalCashedCargo('bill', confirmed.cargos || result.availableCargoList, confirmed.transportCompanyId);
  }

  /** null si se cancela; si se confirma, el grupo de empresa elegido (cuando hay grupos). */
  private async openBillingConfirmationDialog(data: BillingConfirmationDialogData): Promise<BillingConfirmationDialogResult> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const confirmContinue: BillingConfirmationDialogResult = await this.dialog.open(BillingConfirmationDialogComponent, dialogConfig).afterClosed().toPromise();
    return confirmContinue && confirmContinue.state && data.canContinue ? confirmContinue : null;
  }

  public openErrorBills(idsWithBill, idsWithoutBill) {
    const dialogConfig = new MatDialogConfig();
    const title = `MENSAJE DE ERROR`;
    dialogConfig.data = {
      title: title,
      idsWithBill: idsWithBill,
      idsWithoutBill: idsWithoutBill,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    this.dialog.open(CargoUpdateComponent, dialogConfig);
  }
  public openDialogBillXML() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoBillingXmlComponent, dialogConfig).afterClosed().subscribe(
      (result) => {
        if (result && result.state) this.refreshActualList.emit(true);
      }
    );
  }

  public openDialogCashReceipts() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoCashReceiptsComponent, dialogConfig).afterClosed().subscribe(
      (result) => {
        if (result && result.state) this.refreshActualList.emit(true);
      }
    );
  }

  public openDialogCreditNoteAssociation() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoCreditNoteAssociationComponent, dialogConfig).afterClosed().subscribe(
      (result) => {
        if (!result || !result.state) return;
        if (result.response) this.openDialogCreditNoteAssociationSummary(result.response);
        this.refreshActualList.emit(true);
      }
    );
  }

  private openDialogCreditNoteAssociationSummary(response: AccialCreditNoteAssociationResponse) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    dialogConfig.data = { response };
    this.dialog.open(CargoCreditNoteAssociationSummaryComponent, dialogConfig);
  }

  async approveCargosMassive(approve: boolean) {
    const filtersToSearch = this.transformStorageFiltersToSearchFilters();
    const methodToAprove = (cargo: Cargo) => this.freightListService.isCargoToApprove(cargo, this.typeList);
    const methodToDisapprove = (cargo: Cargo) => this.freightListService.isCargoToDisapprove(cargo, this.typeList);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `${approve ? 'Aprobar' : 'Rechazar'} servicios`,
      subtitle: `Ingrese los consecutivos de los servicios que desea ${approve ? 'aprobar' : 'rechazar'} separados por una coma.`,
      label: `Servicios a ${approve ? 'aprobar' : 'rechazar'}`,
      confirmButton: "Continuar",
      method: this.freightListService.getListCargo.bind(this.freightListService),
      validationToCheckValid: approve ? methodToAprove.bind(this) : methodToDisapprove.bind(this),
      filters: filtersToSearch
    }
    let result: {
      availableList: Cargo[],
      unavailableList: ((Cargo & { errorMessage?: string }))[],
      nonExistentList: number[],
      consecutiveList: string[]
    } = await this.dialog.open(MassiveCargoOperationComponent, dialogConfig).afterClosed().toPromise();
    if (!result) return;
    if (result.availableList.length && result.availableList.length !== result.consecutiveList.length) {
      let messageList: string[] = [
        `Consecutivos ingresados: ${result.consecutiveList.join(', ')}`,
      ];
      result.availableList.length && messageList.push(`Servicios habilitados: ${result.availableList.map(cargo => cargo.consecutive).join(', ')}`);
      result.unavailableList.length && messageList.push(`Servicios inhabilitados: ${result.unavailableList.map(cargo => `${cargo.consecutive} (${cargo.errorMessage})`).join(', ')}`);
      result.nonExistentList.length && messageList.push(`Servicios no encontrados/registrados: ${result.nonExistentList.join(', ')}`);
      dialogConfig.data = {
        title: result.availableList.length ? '¿Deseas continuar?' : 'No es posible continuar',
        messageList,
      };
      if (result.availableList.length) {
        dialogConfig.data['showYesBtn'] = true;
        dialogConfig.data['showNoBtn'] = true;
        dialogConfig.data['hideBtnCancel'] = true;
      }
      else {
        dialogConfig.data.descriptionHTML = `
          <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
            <i class="fas fa-exclamation-triangle mr-2"></i><span>No hay ningún servicio habilitado</span>
          </div>`;
        dialogConfig.data['hideBtnCancel'] = false;
        dialogConfig.data['hideBtnConfirm'] = true;
      }
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      const confirmContinue = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
      if (!confirmContinue || !confirmContinue.state || !result.availableList.length) return;
    }

    this.approveOrDisapproveCargo(approve, result.availableList);
  }

  async approveCargosByLicensePlate(approve: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      mode: approve ? 'approve' : 'reject',
      typeList: this.typeList,
      baseFilters: this.transformStorageFiltersToSearchFilters(),
      searchMethod: this.freightListService.getListCargo.bind(this.freightListService),
      validationMethod: approve
        ? (cargo: Cargo) => this.freightListService.isCargoToApprove(cargo, this.typeList)
        : (cargo: Cargo) => this.freightListService.isCargoToDisapprove(cargo, this.typeList)
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;

    const result: { availableList: Cargo[] } = await this.dialog
      .open(CargoOperationByPlateComponent, dialogConfig)
      .afterClosed()
      .toPromise();
    if (!result || !result.availableList || !result.availableList.length) return;
    this.approveOrDisapproveCargo(approve, result.availableList);
  }

  isSomeCargosToReverse(cargos: Cargo[] = this.itemsSelecteds): { canProceed: boolean, error?: string } {
    if (!cargos || !cargos.length)
      return { canProceed: false, error: 'No hay servicios seleccionados' };
    for (const cargo of cargos) {
      const result = this.freightListService.isCargoToReverse(cargo, this.typeList);
      if (!result.isSelectable || !result.isEnabled)
        return { canProceed: false, error: result.errorMessage ? result.errorMessage : `No es posible reversar el servicio ${cargo.consecutive}` };
    }
    return { canProceed: true };
  }

  // Reversar aprobación/rechazo de los servicios seleccionados
  async reverseCargos(cargos: Cargo[] = this.itemsSelecteds) {
    if (!cargos.length || this.filterBy !== "cargo") return;
    const isSomeCargosToProceed = this.isSomeCargosToReverse(cargos);
    if (!isSomeCargosToProceed.canProceed) return this.snackBarService.openSnackBar(isSomeCargosToProceed.error, undefined, "alert");
    const approvedCargos = cargos.filter(cargo => cargo.approval === "Approved");
    if (approvedCargos.length) {
      const result = await this.cargoManager.preventContinueCargosWithBill(approvedCargos);
      if (!result || !result.continueAnyway) return;
    }
    this.openModalReverseCargo(cargos);
  }

  private openModalReverseCargo(cargos: Cargo[] = this.itemsSelecteds) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: cargos.length > 1
        ? '¿Deseas reversar los servicios seleccionados?'
        : `¿Deseas reversar el servicio ${cargos[0].consecutive}?`,
      description: (cargos.length > 1 ? 'Se seleccionaron los servicios: ' : 'Se seleccionó el servicio: ') +
        cargos.map(cargo => cargo.consecutive).join(', '),
      showYesBtn: true,
      showNoBtn: true,
      hideBtnCancel: true
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig).afterClosed().subscribe((result) => {
      if (result && result.state) this.reverseApproveCargos(cargos);
    });
  }

  private reverseApproveCargos(cargos: Cargo[]) {
    const data: CargoApprovalRequest = {
      cargos: cargos.map(cargo => ({ cargoId: cargo.id })),
      userId: this.authService.getUserSession().information.document,
      userName: this.authService.getUserSession().information.name
    };
    this.spinner.show();
    this.freightListService.approvedCargo(data).subscribe({
      next: (result: Cargo[]) => {
        this.spinner.hide();
        this.checkResponseReverse(result);
      },
      error: (error) => {
        this.spinner.hide();
        if (error && error.error) this.checkResponseReverse(error.error);
        else this.snackBarService.openSnackBar(error, undefined, "error");
      }
    });
  }

  checkResponseReverse(cargos: Cargo[]) {
    const errorList: string[] = [];
    const successList: string[] = [];
    if (!cargos || !cargos.length)
      return this.snackBarService.openSnackBar(`Ocurrió un error al reversar los servicios`, undefined, "error");
    cargos.forEach((cargo) => {
      if (cargo.approval === 'Approved' || cargo.approval === 'Rejected')
        errorList.push(`Servicio ${cargo.consecutive}: Error al reversar`);
      else successList.push(`${cargo.consecutive}`);
    });
    const messageSuccess = successList.length
      ? `Se reversó correctamente la aprobación/rechazo de los servicios: ${successList.join(', ')}`
      : "";
    this.showResponseReverse({ errorList, messageSuccess });
  }

  showResponseReverse(content: { errorList?: string[], messageSuccess?: string }) {
    const isError: boolean = !!(content && content.errorList && content.errorList.length);
    const isSuccess: boolean = !!(content && content.messageSuccess && content.messageSuccess.length);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: isError ? "Resultado de la operación" : "Operación exitosa",
      hideBtnCancel: true
    };
    if (isError) dialogConfig.data.iconError = true;
    else dialogConfig.data.icon = true;
    if (isError) {
      dialogConfig.data.descriptionHTML = `Error al intentar reversar la aprobación/rechazo de los siguientes servicios:`;
      dialogConfig.data.messageList = content.errorList;
    }
    if (isSuccess) dialogConfig.data.description = content.messageSuccess;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => this.refreshActualList.emit(true));
  }

  async reverseCargosMassive() {
    const filtersToSearch = this.transformStorageFiltersToSearchFilters();
    const validationFunc = (cargo: Cargo) => this.freightListService.isCargoToReverse(cargo, this.typeList);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Reversar servicios`,
      subtitle: `Ingrese los consecutivos de los servicios que desea reversar la aprobación/rechazo separados por una coma.`,
      label: `Servicios a reversar`,
      confirmButton: "Continuar",
      method: this.freightListService.getListCargo.bind(this.freightListService),
      validationToCheckValid: validationFunc.bind(this),
      filters: filtersToSearch
    };
    let result: {
      availableList: Cargo[],
      unavailableList: ((Cargo & { errorMessage?: string }))[],
      nonExistentList: number[],
      consecutiveList: string[]
    } = await this.dialog.open(MassiveCargoOperationComponent, dialogConfig).afterClosed().toPromise();
    if (!result) return;
    if (result.availableList.length && result.availableList.length !== result.consecutiveList.length) {
      let messageList: string[] = [
        `Consecutivos ingresados: ${result.consecutiveList.join(', ')}`,
      ];
      result.availableList.length && messageList.push(`Servicios habilitados: ${result.availableList.map(cargo => cargo.consecutive).join(', ')}`);
      result.unavailableList.length && messageList.push(`Servicios inhabilitados: ${result.unavailableList.map(cargo => `${cargo.consecutive} (${cargo.errorMessage})`).join(', ')}`);
      result.nonExistentList.length && messageList.push(`Servicios no encontrados/registrados: ${result.nonExistentList.join(', ')}`);
      dialogConfig.data = {
        title: result.availableList.length ? '¿Deseas continuar?' : 'No es posible continuar',
        messageList,
      };
      if (result.availableList.length) {
        dialogConfig.data['showYesBtn'] = true;
        dialogConfig.data['showNoBtn'] = true;
        dialogConfig.data['hideBtnCancel'] = true;
      }
      else {
        dialogConfig.data.descriptionHTML = `
          <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
            <i class="fas fa-exclamation-triangle mr-2"></i><span>No hay ningún servicio habilitado</span>
          </div>`;
        dialogConfig.data['hideBtnCancel'] = false;
        dialogConfig.data['hideBtnConfirm'] = true;
      }
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      const confirmContinue = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
      if (!confirmContinue || !confirmContinue.state || !result.availableList.length) return;
    }

    this.reverseCargos(result.availableList);
  }

  async reverseCargosByLicensePlate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      mode: 'reverse',
      typeList: this.typeList,
      baseFilters: this.transformStorageFiltersToSearchFilters(),
      searchMethod: this.freightListService.getListCargo.bind(this.freightListService),
      validationMethod: (cargo: Cargo) => this.freightListService.isCargoToReverse(cargo, this.typeList)
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;

    const result: { availableList: Cargo[] } = await this.dialog
      .open(CargoOperationByPlateComponent, dialogConfig)
      .afterClosed()
      .toPromise();
    if (!result || !result.availableList || !result.availableList.length) return;
    this.reverseCargos(result.availableList);
  }

  isSomeCargosToApprove(cargos: Cargo[] = this.itemsSelecteds): { canProceed: boolean, error?: string } {
    if (!cargos || !cargos.length)
      return { canProceed: false, error: 'No hay servicios seleccionados' };
    for (const cargo of cargos) {
      const result = this.freightListService.isCargoToApprove(cargo, this.typeList);
      if (!result.isSelectable || !result.isEnabled) return { canProceed: false, error: result.errorMessage ? result.errorMessage : `No es posible aprobar el servicio ${cargo.consecutive}` };
    }
    return { canProceed: true };
  }

  isSomeCargosToDisapprove(cargos: Cargo[] = this.itemsSelecteds): { canProceed: boolean, error?: string } {
    if (!cargos || !cargos.length)
      return { canProceed: false, error: 'No hay servicios seleccionados' };
    for (const cargo of cargos) {
      const result = this.freightListService.isCargoToDisapprove(cargo, this.typeList);
      if (!result.isSelectable || !result.isEnabled) return { canProceed: false, error: result.errorMessage ? result.errorMessage : `No es posible rechazar el servicio ${cargo.consecutive}` };
    }
    return { canProceed: true };
  }

  //Aprobar servicios
  async approveOrDisapproveCargo(approve: boolean, cargos: Cargo[] = this.itemsSelecteds) {
    if (!cargos.length || this.filterBy !== "cargo") return;
    const isSomeCargosToProceed = approve ? this.isSomeCargosToApprove(cargos) : this.isSomeCargosToDisapprove(cargos);
    if (!isSomeCargosToProceed.canProceed) return this.snackBarService.openSnackBar(isSomeCargosToProceed.error, undefined, "alert");
    if (!approve) {
      const result = await this.cargoManager.preventContinueCargosWithBill(cargos.filter(cargo => cargo.approval === "Approved"));
      if (!result || !result.continueAnyway) return;
      return this.openModalDisapproveCargo(cargos);
    }
    this.isSomeErrorApproveCargos = false;
    this.simpleApproveCargo(cargos);
  }

  private async simpleApproveCargo(cargos: Cargo[]) {
    const dialogConfig = new MatDialogConfig();
    const totalValue = cargos.reduce((acc, cargo) => {
      const travelExpensesBalance = this.cargoPaymentsService.getTravelExpensesBalance(cargo.travelExpenses, cargo);
      const balance = this.cargoPaymentsService.getTotalValueBalance(cargo) - travelExpensesBalance;
      return acc + balance;
    }, 0);
    dialogConfig.data = {
      title: cargos.length > 1
        ? `${this.titles.titlesModalApproveCargos} ${this.currencyPipe.transform(totalValue, "COP", "code")} ?`
        : `${this.titles.titlesModalApproveCargo} ${this.currencyPipe.transform(totalValue, "COP", "code")}?`,
      descriptionHTML: (cargos.length > 1 ? 'Se seleccionaron los servicios: ' : 'Se seleccionó el servicio: ') +
        cargos.map(cargo => cargo.consecutive).join(', '),
      showNoBtn: true,
      showYesBtn: true,
      hideBtnCancel: true,
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;

    this.dialog.open(DialogComponent, dialogConfig).afterClosed().subscribe(async (result) => {
      if (result && result.state) {
        const body: CargoApprovalRequestBalance = {
          reason: result.message,
          cargoIds: cargos.map(cargo => cargo.id),
        };
        this.approveCargoBalance(body, true);
      }
    });
  }

  private openModalDisapproveCargo(cargos: Cargo[] = this.itemsSelecteds) {
    const dialogConfig = new MatDialogConfig();
    let initialTitle = cargos.length > 1 ? this.titles.titleRefuseCargos : this.titles.titleRefuseCargo;
    dialogConfig.data = {
      title: initialTitle,
      description: (cargos.length > 1 ? 'Se seleccionaron los servicios: ' : 'Se seleccionó el servicio: ') +
        cargos.map(cargo => cargo.consecutive).join(', '),
      cargos: cargos,
      textArea: true
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig).afterClosed().subscribe((result) => {
      if (result && result.state) {
        const body: CargoApprovalRequestBalance = {
          reason: result.message,
          cargoIds: cargos.map(cargo => cargo.id)
        };
        this.approveCargoBalance(body, false);
      }
    });
  }

  private approveCargoBalance(body: CargoApprovalRequestBalance, state: boolean) {
    this.spinner.show();
    this.freightListService.approvedCargoBalance(body, state).subscribe({
      next: (result: Cargo[]) => {
        this.spinner.hide();
        this.checkResponseApproval(result, state);
      },
      error: (error) => {
        this.spinner.hide();
        if (error.error)
          this.checkResponseApproval(error.error, state);
        else
          this.snackBarService.openSnackBar(error, undefined, "error");
      }
    });
  }

  checkResponseApproval(cargos: Cargo[], state: boolean) {
    let errorList = [];
    let messageSuccess = "";
    const mustReturn = state ? 'Approved' : 'Rejected';
    if (!cargos || !cargos.length)
      return this.snackBarService.openSnackBar(`Ocurrió un error al ${state ? 'aprobar' : 'rechazar'} los servicios`, undefined, "error");
    cargos.forEach((cargo) => {
      if (cargo.approval !== mustReturn)
        errorList.push(`Servicio ${cargo.consecutive}: Error al ${state ? 'aprobar' : 'rechazar'}`);
      else messageSuccess += `Servicio ${cargo.consecutive}`;
    });
    if (messageSuccess)
      messageSuccess = `${state ? 'Se aprobaron' : 'Se rechazaron'} correctamente los servicios: ${messageSuccess}`
    this.showResponseApproval({ errorList, messageSuccess, cargos }, state);
  }

  showResponseApproval(content: { errorList?, messageSuccess?, cargos?}, state: boolean) {
    const isError: boolean = content && content.errorList && content.errorList.length;
    const isSuccess: boolean = content && content.messageSuccess && content.messageSuccess.length;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: isError ? "Resultado de la operación" : "Revisión exitosa",
      hideBtnCancel: true,
    };
    if (isError) dialogConfig.data.iconError = true;
    else dialogConfig.data.icon = true;

    if (isError) {
      dialogConfig.data.descriptionHTML = `Error al intentar ${state ? 'aprobar' : 'rechazar'} las siguientes Remesas:`;
      dialogConfig.data.messageList = content.errorList;
    }
    if (isSuccess) dialogConfig.data.description = content.messageSuccess;

    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      this.refreshActualList.emit(true);
      if (content && content.cargos && content.cargos.some((cargo: Cargo) => 'message' in cargo)) {
        const cargoToVerifyReceivable = content.cargos.filter((cargo: Cargo) => (cargo.approval === 'Rejected' || cargo.approval === 'Approved') && cargo.message);
        if (cargoToVerifyReceivable.length)
          this.verifyReceivableModifications(cargoToVerifyReceivable);
      }
    });
  }

  verifyReceivableModifications(cargos: Cargo[]) {
    const dialogConfig = new MatDialogConfig();
    let title = '';
    if (cargos && cargos[0] && cargos[0].message) {
      title = `${cargos[0].message}. ¿Desea hacer el abono a la cartera?`;
    }
    dialogConfig.data = {
      title: title,
      showYesBtn: true,
      showNoBtn: true
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.receivableList(cargos[0].licensePlate);
      }
    });
  }

  receivableList(licensePlate: string) {
    let observableVehicleInfo;
    const $observerVehicleInfo = {
      next: (vehicle: Vehicle) => {
        if (vehicle && vehicle.bankAccountBalance) {
          this.holder = {
            name: vehicle.bankAccountBalance.name,
            document: vehicle.bankAccountBalance.document,
            documentTypeName: vehicle.bankAccountBalance.documentTypeName
          };
          let debtor = this.authService.createHolderObjReceivables(vehicle);
          return this.receivableService.getReceivableList(null, null, vehicle.bankAccountBalance.document, null, null, 'list', debtor && debtor.document ? debtor.document : null);
        } else {
          this.snackBarService.openSnackBar('No existe un usuario asociado al balance de la cuenta', undefined, "error")
          return of(null);
        }
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        return EMPTY;
      },
      finally: () => {
        this.spinner.hide();
        observableVehicleInfo.unsubscribe();
      }
    };
    this.spinner.show();
    const observableVehicle = this.vehiclesService.getVehicleFromOwnCompany(licensePlate).pipe(switchMap(vehicle => observableVehicleInfo = $observerVehicleInfo.next(vehicle)))
      .subscribe({
        next: (listModifications) => {
          this.spinner.hide();
          if (listModifications) {
            this.openModificationsList(listModifications);
          } else {
            this.snackBarService.openSnackBar("No hay modificaciones para mostrar", undefined, "alert")
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar("Hubo un error trayendo las modificaciones. Vuelva a intentarlo", undefined, "alert")
        },
        complete: () => {
          this.spinner.hide();
          observableVehicle.unsubscribe();
        }
      })
  }

  openModificationsList(listReceivables) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      listReceivables: listReceivables,
      holder: this.holder
    }
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.disableClose = true;
    const dialogRef = this.matDialog.open(ReceivableModificationsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'undefined') {
        this.snackBarService.openSnackBar('Por favor rechace o apruebe la modificacion a la cartera para poder continuar', undefined, 'alert')
      }
    })
  }

  async fulfillCargosRndcMassive() {
    const filtersToSearch = this.transformStorageFiltersToSearchFilters();
    const validationFunc = (cargo: Cargo) => this.freightListService.isCargoToRndcFulfill(this.typeList, cargo, filtersToSearch);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Cumplir servicios ante el RNDC`,
      subtitle: `Ingrese los consecutivos de los servicios que desea cumplir ante el RNDC separados por una coma.`,
      label: `Servicios a cumplir ante el RNDC`,
      confirmButton: "Continuar",
      method: this.freightListService.getListCargo.bind(this.freightListService),
      validationToCheckValid: validationFunc,
      filters: filtersToSearch
    }
    let result: {
      availableList: Cargo[],
      unavailableList: ((Cargo & { errorMessage?: string }))[],
      nonExistentList: number[],
      consecutiveList: string[]
    } = await this.dialog.open(MassiveCargoOperationComponent, dialogConfig).afterClosed().toPromise();
    if (!result) return;
    let messageList: string[] = [
      `Consecutivos ingresados: ${result.consecutiveList.join(', ')}`,
    ];
    result.availableList && result.availableList.length && messageList.push(`Servicios habilitados: ${result.availableList.map(cargo => cargo.consecutive).join(', ')}`);
    result.unavailableList && result.unavailableList.length && messageList.push(`Servicios inhabilitados: ${result.unavailableList.map(cargo => `${cargo.consecutive} (${cargo.errorMessage})`).join(', ')}`);
    result.nonExistentList && result.nonExistentList.length && messageList.push(`Servicios no encontrados/registrados: ${result.nonExistentList.join(', ')}`);
    dialogConfig.data = {
      title: result.availableList.length ? '¿Deseas continuar?' : 'No es posible continuar',
      messageList,
    };
    if (result.availableList.length) {
      dialogConfig.data['showYesBtn'] = true;
      dialogConfig.data['showNoBtn'] = true;
      dialogConfig.data['hideBtnCancel'] = true;
    }
    else {
      dialogConfig.data.descriptionHTML = `
        <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i><span>No hay ningún servicio habilitado</span>
        </div>`;
      dialogConfig.data['hideBtnCancel'] = false;
      dialogConfig.data['hideBtnConfirm'] = true;
    }
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const confirmContinue = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!confirmContinue || !confirmContinue.state || !result.availableList.length) return;
    this.isSomeErrorApproveCargos = false;
    this.fulfillCargos(result.availableList);
  }

  async fulFillCargosRndc(cargos: Cargo[] = this.itemsSelecteds) {
    if (!cargos.length || this.filterBy !== "cargo") return;
    if (this.blockDocumentRecreationCargos(cargos)) return;
    this.isSomeErrorApproveCargos = false;
    const response = await this.cargoManager.openDialogConfirm('¿Estás seguro que deseas cumplir los servicios seleccionados ante el RNDC?',
      cargos.length > 1
        ? `Se cumplirán los servicios ${cargos.map((cargo: Cargo) => cargo.consecutive).join(', ')} ante el RNDC`
        : `Se cumplirá el servicio ${cargos[0].consecutive} ante el RNDC`
    );
    if (!response.confirm) return;
    this.fulfillCargos(cargos);
  }

  private fulfillCargos(cargos: Cargo[]) {
    if (this.blockDocumentRecreationCargos(cargos)) return;
    const body: { cargoConsecutives: number[] } = { cargoConsecutives: cargos.map((cargo: Cargo) => cargo.consecutive) };
    this.spinner.show();
    this.cargoDetailService.fulFillCargosRndc(body).subscribe(
      (data: { cargos: Cargo[], failedCargoConsecutives: { consecutive: number, errorMessage: string }[] }) => {
        this.checkResponseFulFillRndc(data.cargos, data.failedCargoConsecutives);
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        if (!this.isSomeErrorApproveCargos && error && error.error && error.error.length &&
          error.error.every(error => !!this.utils.canOpenLogisticTimes(error).canOpen))
          this.askManualOrAutomatedDatesForFulFillRndc(error && error.error ? error.error : null);
        else if (error.error)
          this.checkResponseFulFillRndc(error.error);
        else
          this.snackBarService.openSnackBar("Ocurrió un error al cumplir los servicios ante el RNDC", undefined, "error");
      }
    );
  }

  private blockDocumentRecreationCargos(cargos: Cargo[]): boolean {
    const blockedCargos = (cargos || []).filter(isDocumentRecreationInProgress);
    if (!blockedCargos.length) return false;
    this.snackBarService.openSnackBar(
      `${DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE} Servicios: ${blockedCargos.map(cargo => cargo.consecutive).join(', ')}.`,
      undefined,
      'alert'
    );
    return true;
  }

  checkResponseFulFillRndc(cargos: Cargo[], failedCargoConsecutives?: { consecutive: number, errorMessage: string }[]) {
    let errorList = [];
    let errorCargos: Cargo[] = [];
    let messageSuccess = "";
    if (!cargos || !cargos.length)
      return this.snackBarService.openSnackBar("Ocurrió un error al cumplir los servicios ante el RNDC", undefined, "error");
    cargos.forEach((cargo) => {
      if (!cargo.ministry || !cargo.manifest || !cargo.manifestAuthorization)
        return messageSuccess += messageSuccess ? `, Servicio ${cargo.consecutive}` : `Servicio ${cargo.consecutive}`;
      const errors = this.searchErrorsInCargos(cargo);
      const failedCargo = failedCargoConsecutives && failedCargoConsecutives.find(failedCargo => failedCargo.consecutive === cargo.consecutive);
      if (failedCargo) {
        errorList.push(`Servicio ${cargo.consecutive}: ${failedCargo.errorMessage}`);
        errorCargos.push(cargo);
      } else if (errors.length) {
        errorList.push(errors);
        errorCargos.push(cargo);
      } else messageSuccess += messageSuccess ? `, Servicio ${cargo.consecutive}` : `Servicio ${cargo.consecutive}`;
    });
    if (messageSuccess)
      messageSuccess = `Se cumplieron correctamente los servicios: ${messageSuccess}`
    if (errorCargos.length && !this.isSomeErrorApproveCargos && errorCargos.every(cargo => !!this.utils.canOpenLogisticTimes(cargo).canOpen))
      this.askManualOrAutomatedDatesForFulFillRndc(errorCargos);
    else this.showResponseFulFillRndc({ errorList, messageSuccess });
  }

  searchErrorsInCargos(cargo: Cargo): string[] {
    let errorList = [];
    const manifestError = this.utils.getNestedValue(cargo, 'manifestError.error');
    const manifestCargo = this.utils.getNestedValue(cargo, 'manifest');
    if (manifestError)
      errorList.push(`Servicio ${cargo.consecutive}: ${manifestCargo ? `${manifestCargo} - ` : ''}${manifestError}`);
    const destinations: Destination[] = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    if (destinations && destinations.length) {
      destinations.forEach((destination) => {
        if (destination.addresses && destination.addresses.length) {
          destination.addresses.forEach((address) => {
            const consignments = this.utils.getNestedValue(address, 'consignments');
            const ministryError = this.utils.getNestedValue(address, 'ministryError.error');
            if (ministryError)
              errorList.push(`Servicio ${cargo.consecutive}${consignments && consignments[0] ? `${consignments[0]} - ` : ''}${ministryError}`);
          });
        }
      });
    };
    return errorList;
  }

  private async askManualOrAutomatedDatesForFulFillRndc(cargos: Cargo[]) {
    this.isSomeErrorApproveCargos = true;
    let manual_consignment_dates;
    if (cargos.some((cargo: Cargo) => cargo.ministry && !this.utils.isSameCity(cargo))) {
      manual_consignment_dates = await this.askManualOrAutomatedDates();
      if (!this.utils.isDefined(manual_consignment_dates)) return;
    }
    this.openModalLogisticTimesCargo(manual_consignment_dates, cargos);
  }

  private async askManualOrAutomatedDates(): Promise<boolean> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: this.isSomeErrorApproveCargos
        ? `Ocurrió un error al cumplir`
        : `¿Desea ingresar manualmente las fechas de los cumplidos?`,
      descriptionHTML: this.isSomeErrorApproveCargos
        ? `<b class="text-bold">¿Desea ingresar manualmente las fechas de los cumplidos?</b><br>
            Si selecciona no, los valores serán calculados automáticamente.`
        : `Si selecciona no, los valores serán calculados automáticamente.`,
      showNoBtn: true,
      showYesBtn: true,
      hideBtnCancel: true,
      untilDate: new Date()
    };
    if (this.isSomeErrorApproveCargos) dialogConfig.data['iconError'] = true;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return !!(result && result.state);
  }

  private async openModalLogisticTimesCargo(manual_consignment_dates: boolean = false, cargos: Cargo[] = this.itemsSelecteds) {
    const dialogConfig = new MatDialogConfig();
    let initialTitle = '';
    initialTitle = cargos.length > 1 ? this.titles.titlesModalFulFillCargos : this.titles.titlesModalFulFillCargo;
    dialogConfig.data = {
      title: 'Registro de monitoreo de manifiesto',
      description: (cargos.length > 1 ? 'Se seleccionaron los servicios: ' : 'Se seleccionó el servicio: ') +
        cargos.map(cargo => cargo.consecutive).join(', '),
      cargos: cargos,
      manual_consignment_dates,
      date: true,
      untilNow: new Date(),
      type: 'logisticTimesModal'
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.dialog.open(ApproveCargoDialogComponent, dialogConfig).afterClosed().toPromise();
    if (!!result) this.changeLogisticTimes(result, cargos);
  }

  async changeLogisticTimes(result, cargos: Cargo[] = this.itemsSelecteds) {
    this.spinner.show();
    try {
      await this.freightListService.changeLogisticsTimes(result).toPromise();
      this.fulfillCargos(cargos);
    } catch (error) {
      this.spinner.hide();
      if (error.error && error.error.message) this.snackBarService.openSnackBar(error.error.message, undefined, 'error');
      else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  private emitLogisticTimesCargo(body: CargoApprovalRequest, state: boolean) {
    this.freightListService.approvedCargo(body, state).subscribe({
      next: (result: Cargo[]) => {
        this.spinner.hide();
        this.checkResponseFulFillRndc(result);
      },
      error: (error) => {
        this.spinner.hide();
        if (error.error)
          this.checkResponseFulFillRndc(error.error);
        else
          this.snackBarService.openSnackBar(error, undefined, "error");
      }
    });
  }

  async showResponseFulFillRndc(data: { errorList: string[], messageSuccess: string }) {
    const hasErrors = data && data.errorList && data.errorList.length;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: hasErrors ? "Resultado de la operación" : "Revisión exitosa",
      hideBtnCancel: true,
    };
    if (hasErrors) dialogConfig.data.iconError = true;
    else dialogConfig.data.icon = true;

    if (hasErrors) {
      dialogConfig.data.descriptionHTML = `Error al intentar cumplir los siguientes servicios ante el RNDC:`;
      dialogConfig.data.messageList = data.errorList;
    } else dialogConfig.data.description = data.messageSuccess;

    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    this.refreshActualList.emit(true);
  }

  //Editar facturas o comprobantes
  public openDialogEdit(type, data) {
    if (!this.itemsSelecteds.length || this.filterBy !== "cargo") return;
    if (!this.transportCompanyGuard.ensureSameTransportCompany(this.itemsSelecteds, this.listTransportCompanyId)) return;
    this.validateToOperations = 'touched';
    if (!this.companyToOperations.value || !this.companyToOperations.value.companyId) {
      this.snackBarService.openSnackBar("Debe seleccionar una compañia", undefined, "alert");
      return;
    } else if (!this.itemsSelecteds.every(cargo => cargo.idCompany === this.companyToOperations.value.companyId)) {
      this.snackBarService.openSnackBar("Todas los servicios deben pertenecer a la compañía seleccionada", undefined, "alert");
      return;
    }
    const dialogConfig = new MatDialogConfig();
    const title = `Modificar ${data}`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(CargoUpdateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (this.utils.isDefined(result)) {
        let ids = this.itemsSelecteds.map((cargo) => {
          return cargo.id;
        });
        this.updateInvoice(ids, type, result);
      }
    });
  }
  public updateInvoice(idCargos, type, value) {
    this.spinner.show();
    this.cargoDetailService.editInvoice(idCargos, type, value).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data && data.message) {
          this.snackBarService.openSnackBar(data.message);
          this.refreshActualList.emit(true);
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          `Ocurrió un error al desasociar`,
          undefined,
          "error"
        );
      }
    );
  }

  //Desasociar facturas o comprobantes
  public confirmDisassociate(type, data) {
    if (!this.itemsSelecteds.length || this.filterBy !== "cargo") return;
    this.validateToOperations = 'touched';
    if (!this.isRootNit) this.companyToOperations.setValue({ nit: this.authService.getUserSession().clientCompanyId });
    if (!this.companyToOperations.value || !this.companyToOperations.value.companyId) {
      this.snackBarService.openSnackBar("Debe seleccionar una compañia", undefined, "alert");
      return;
    } else if (!this.itemsSelecteds.every(cargo => cargo.idCompany === this.companyToOperations.value.companyId)) {
      this.snackBarService.openSnackBar("Todos los servicios deben pertenecer a la compañía seleccionada", undefined, "alert");
      return;
    }
    const dialogConfig = new MatDialogConfig();
    const title = `¿Estás seguro que deseas desasociar todos los ${data} seleccionados?`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        let ids = this.itemsSelecteds.map((cargo) => {
          return cargo.id;
        });
        this.disassociate(ids, type);
      }
    });
  }
  public disassociate(idCargos, type) {
    this.spinner.show();
    this.cargoDetailService.disassociate(idCargos, type).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data && data.message) {
          this.snackBarService.openSnackBar(data.message);
          this.refreshActualList.emit(true);
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          `Ocurrió un error al desasociar`,
          undefined,
          "error"
        );
      }
    );
  }

  public generateJournalByItemsSelected() {
    if (!this.itemsSelecteds.length || this.filterBy !== "cargo") return;
    const dialogConfig = new MatDialogConfig();
    const title = `¿Estás seguro que deseas generar los Comprobantes Contables para los servicios seleccionados?`;
    const listConsecutives = this.utils.getItemsCheked(this.itemsSelecteds, "consecutive");
    dialogConfig.data = {
      title: title,
      descriptionHTML: `<p class="text-center">Se generarán los comprobantes para los servicios: ${listConsecutives.join(', ')}</p>`,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.generateJournal();
      }
    });
  }

  /** Empresa de transporte de la pastilla del listado (viaja en los filtros); null si no aplica. */
  private get listTransportCompanyId(): string {
    const currentFilters = this.filters && this.filters !== "null" ? this.utils.decodeFilters(this.filters) : {};
    return currentFilters['transportCompanyId'] || null;
  }

  public confirmGenerateJournal() {
    const dialogConfig = new MatDialogConfig();
    // La generación es por periodo (no por selección): se acota a la empresa de la pastilla del listado.
    dialogConfig.data = {
      title: 'Generación de comprobantes contables',
      type: 'withoutPayment',
      transportCompanyId: this.listTransportCompanyId,
    };
    dialogConfig.height = "auto";
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(CargoGenerateFilterComponent, dialogConfig);
  }

  public generateJournal(cargosError?: Cargo[]): void {
    this.spinner.show();
    const list = cargosError && cargosError.length ? cargosError : this.itemsSelecteds;
    const listConsecutives = list.map((cargo: Cargo) => cargo.consecutive);
    this.siigoManager.generateJournal(listConsecutives)
      .then((response) => {
        this.checkResponseGenerateJournal(response);
      })
      .catch((error) => {
        this.checkResponseGenerateJournal(error);
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private checkResponseGenerateJournal(data) {
    this.siigoManager.showResponseGenerateJournal(data).then((dataTryAgain: Cargo[]) => {
      if (dataTryAgain && dataTryAgain.length) {
        this.generateJournal(dataTryAgain);
        this.refreshActualList.emit(true);
      }
    });
  }

  openModalMassivePaymentCargo() {
    let staticFilters = this.transformStorageFiltersToSearchFilters();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.data = {
      filters: staticFilters
    }
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(MassivePaymentsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((cargos: Cargo[]) => {
      if (cargos && cargos.length) {
        this.itemsSelecteds = [];
        this.itemsSelecteds = cargos;
        this.openModalPaymentCargo('massive');
      }
    });
  }

  openModalMoveAdvance() {
    const config = new MatDialogConfig();
    config.data = { cargos: this.itemsSelecteds };
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.SMALL_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;

    this.matDialog.open(MoveAdvanceDialogComponent, config);
  }

  private transformStorageFiltersToSearchFilters(): string {
    const staticFilters = sessionStorage.getItem('_filterListStatic');
    const filtersAsObj = this.utils.decodeFilters(staticFilters);
    if (filtersAsObj['approval'] && filtersAsObj['approval'] === 'all') delete filtersAsObj['approval'];
    if (filtersAsObj['ministryFulfillment'] && filtersAsObj['ministryFulfillment'] === 'all') delete filtersAsObj['ministryFulfillment'];
    let filtersToSearch: string = '';
    Object.keys(filtersAsObj).forEach((key) => {
      if (Array.isArray(filtersAsObj[key])) {
        if (filtersAsObj[key].length)
          filtersToSearch += "&" + key + "=" + encodeURIComponent(JSON.stringify(filtersAsObj[key]));
      } else
        filtersToSearch += "&" + key + "=" + encodeURIComponent(filtersAsObj[key]);
    });

    return filtersToSearch;
  }

  ngOnDestroy(): void {
    if (this.rndcContingencySub) this.rndcContingencySub.unsubscribe();
  }

  hasIntegration(typeBilling: 'bill' | 'income'): boolean {
    const integrationBillChannels = [IntegrationEnum.SIIGO.toLowerCase(), IntegrationEnum.WORLD_OFFICE.toLowerCase(), IntegrationEnum.BUSINESS_CENTRAL.toLowerCase()];
    const integrationIncomeChannels = [IntegrationEnum.SIIGO.toLowerCase()];
    const integrationChannels = typeBilling === 'bill' ? integrationBillChannels : integrationIncomeChannels;
    return this.authService && this.authService.getCompany().integrationCredentials &&
      this.authService.getCompany().integrationCredentials.length &&
      this.authService.getCompany().integrationCredentials.some(integration => integration && integration.integrationChannel &&
        integrationChannels.includes(integration.integrationChannel.toLowerCase()) && integration.state);
  }

  get showBillingXML(): boolean {
    return this.typeList === "charges" &&
      this.permissionRole.hasPermission(
        this.permission.payments.module,
        this.permission.payments.billingXML
      );
  }

  /**
   * Teclogi agrupa las tres cargas de facturación en un solo menú.
   * El resto de las empresas conserva el botón suelto del XML del Ministerio.
   */
  get showUploadsMenu(): boolean {
    return this.showBillingXML && this.isTeclogiUser;
  }

  get showSingleBillingXML(): boolean {
    return this.showBillingXML && !this.isTeclogiUser;
  }

  get canMoveAdvance(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.moveAdvance)
      && this.typeList === 'paymentAdvanceCargo';
  }

  private get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }
}
